var _vars = require('./vars')._vars;
var generateQueryId = require('./vars').generateQueryId; // MEDAIS-2052: Import generateQueryId
var _html = require('./html')._html;
var stripTags = require('./html').stripTags;
var shared = require('./shared');
var difyApi = require('./providers/dify/api');
var history = require('./history');
var suggested = require('./suggested-prompts');
var aiGating = require('./ai-gating');
var copyConversation = require('./copy-conversation');
var ads = require('./ads');
const vars = require('./vars');

function parseUrlParameters() {
	const params = new URLSearchParams(window.location.search);
	return {
	query: params.get('query'),
	article_guid: params.get('article_guid'),
	article_title: decodeURIComponent(params.get('article_title') || ''),
	content_type_guid: params.get('content_type_guid')
	};
}

window.onpopstate = function() {
	var fullWidthEl = document.querySelector('.ai-search-full-width-container');
    if (fullWidthEl) {
		var stpBtn = document.querySelector('.ai-search-stop-btn-dify')
		if(stpBtn.classList.contains('active')) {
			shared.handleStopGenerate();
			stpBtn.classList.remove('active');
		}
        // Reset UI state
        fullWidthEl.classList.remove('animate');
        fullWidthEl.classList.remove('animate-out');
        fullWidthEl.classList.remove('has-question-rendered');
        fullWidthEl.classList.add('landing-page');
        fullWidthEl.classList.remove('mobile-card-active');
        fullWidthEl.classList.remove('bg-white');
        fullWidthEl.classList.remove('fixed-height');
		fullWidthEl.classList.remove('scrollable-header-layout')
        
        // Reset input state
        var searchEl = document.querySelector('#ai-search-input-modal');
        searchEl.value = '';
        searchEl.disabled = false;
		searchEl.placeholder = 'Ask anything';
		searchEl.focus();
        
        // Reset other UI elements
		if(document.querySelector('.ai-search-more')) {
			document.querySelector('.ai-search-more').classList.remove('active');
		}
        document.querySelector('.suggested-container').classList.add('active');
        if(document.querySelector('.history-panel')) {
            document.querySelector('.history-panel').classList.remove('active');
			document.querySelector('.history_btn').style.display = 'flex';
        }
        
        // Clear existing conversation
        document.querySelectorAll('.ai-search-content .ai-search-question, .ai-search-content .ai-search-answer, .ai-search-content .ai-search-asking-question').forEach(function(el) {
            el.remove();
        });
        
        // Clean up all persistent ads
        ads.cleanupAllAds();

        // Reset conversation ID if using Dify provider
        if(_vars.provider === 'dify') {
            _vars.conversationId = '';
        }
    }
	window.history.pushState({view: 'landingpage'}, '');
}

function closeLayer(event) {
	// Stop any in-flight AI query when the modal is closed (article pages only; self-guarded).
	shared.abortActiveQuery();
    // Add slide down animation before closing
	var fab = document.getElementById('ai-search-fab');
	if (fab) {
		fab.classList.add('active');
		// Restore FAB display for article pages
		if (_vars.isArticlePage) {
			fab.style.display = '';
		}
	}
	var progressEl = document.querySelector('.ai-search-progress');
	var stopBtnEl = document.querySelector('.ai-search-stop-btn-dify');
	if (!document.querySelector('.ai-search-answer.active') && !document.querySelector('.ai-gate-content.active') 
		&& progressEl && !progressEl.classList.contains('active') 
		&& stopBtnEl && !stopBtnEl.classList.contains('active')
		&& document.body.classList.contains('ai-search-modal-maximized')) {
		document.body.classList.remove('ai-search-modal-maximized');
	}
	// For article pages, always remove minimized class when closing to prevent CSS conflicts on reopen
	if (_vars.isArticlePage) {
		document.body.classList.remove('ai-search-modal-minimized');
	}
	
	// Clean up hover-ai styles to prevent content shift
	document.body.classList.remove('hover-ai');
	document.body.removeAttribute('style');
	var modalEl = document.querySelector('#ai-search-modal');
	var fabEl = document.querySelector('#ai-search-fab');
	if (modalEl) modalEl.removeAttribute('style');
	if (fabEl) fabEl.removeAttribute('style');
	
    const modal = document.querySelector('#ai-search-modal');
    if (modal && _vars.isArticlePage) {
        modal.classList.add('slide-down-exit');
        
        // Wait for animation to complete before hiding
        setTimeout(function() {
            modal.classList.remove('slide-down-exit');
            document.body.classList.remove('show-ai-search-modal');
            performCloseLayerActions(event);
        }, 300);
    } else {
        document.body.classList.remove('show-ai-search-modal');
        performCloseLayerActions(event);
    }
}

function performCloseLayerActions(event) {

// Hide 'Start New'
    var aiSearchNew = document.querySelector('.ai-search-new');
    var aiSearchInstructions = document.querySelector('.ai-search-instructions');
    if (aiSearchNew) aiSearchNew.classList.remove('active');
    if (aiSearchInstructions) aiSearchInstructions.classList.remove('active');

// For regular article pages, hide the sticky input wrapper and show the sparkle FAB again when modal is closed
if (_vars.isArticlePage) {
    var articleSearchWrapper = document.querySelector('.article-search-wrapper');
    if (articleSearchWrapper) {
        articleSearchWrapper.style.display = 'none';
    }
	var articleSearchSparkle = document.querySelector('.article-search-sparkle')
	if(articleSearchSparkle){
		articleSearchSparkle.style.display = "flex";
	}
    // Clear the input field
    var articleSearchBar = document.querySelector('#article-search-bar');
    if (articleSearchBar) {
        articleSearchBar.value = '';
        // Hide the send icon since input is now empty
        var articleIconRight = document.querySelector('.article-search-icon-right');
        if (articleIconRight) {
            articleIconRight.style.display = 'none';
        }
    }
}

// closeLayer wiped the FAB's inline style (removeAttribute('style')), which cleared the
// column-edge `right` set by alignFeedFabToColumn. Re-apply it now that the FAB is visible
// again so it doesn't snap back to the CSS viewport-edge fallback on A2A feeds.
alignFeedFabToColumn();

if (typeof event != 'undefined') { // don't call this when it's full-page driver link, wmdTrack calls conflict
wmdTrack('ai-search_exit', this);
if (_vars.isArticlePage === true) {
	// On article pages, scanOmniVars()'s internal exit pageview would refresh the host ads with the
	// PVID changed during the query. Reset the pageName back to the article (as swapPageNamesDesktop
	// does on mouseleave), sync vars via scanOmniVars(true) without firing its pageview, then fire the
	// exit pageview ourselves with noAdRefresh=true.
	s_md.pageName = _urlClean(window.location.href.split('?')[0]);
	scanOmniVars(true);
	if (typeof wmdPageview !== 'undefined') {
		wmdPageview(s_md.pageName, 1, true);
	}
} else {
	scanOmniVars(); // reset the pageName when exiting layer and send the pageView call
}
}
shared.toggleDrawer(false);
document.querySelectorAll('.feedback-option').forEach(function(el) {
el.classList.remove('checked');
});
}


function handleHistoryEvents() {
    var historyBtn = document.querySelector('.history_btn');
    if(historyBtn) {
        // Token generation is handled by suggested-prompts.js init()
        // No need to generate token here to avoid duplicate API calls
        history.handleHistoryEvents();
    }
}

function aiSchPageview(pageNum) {
	scanOmniVars(true); // clear variables which should only be on initial pageView
	// On article pages, pass noAdRefresh=true so AI-search pageviews never refresh the host article's ads
	// (e.g. reopening search after a query, when GenPVID() has already changed the PVID).
	var noAdRefresh = _vars.isArticlePage === true;
	wmdPageview('medscape.com/ai-search', pageNum, noAdRefresh); // send the pageview with custom pageName
	if (aiGating.shouldGateAIQuery() && event.type !== 'scroll') {
		wmdTrack('ai-search_login-appear');
		wmdPageview('medscape.com/ai-search', pageNum, noAdRefresh);
	}
}

function swapPageNamesDesktop() {
	var modal = document.querySelector('#ai-search-modal');
	if (!modal) return;
	
	modal.addEventListener('mouseenter', function() {
		s_md.pageName = 'medscape.com/ai-search';
	});
	modal.addEventListener('mouseleave', function() {
		s_md.pageName = _urlClean(window.location.href.split('?')[0]);
		scanOmniVars(true);
	});
}

function stopDesktopBgScroll() {
	try {
		var contentEl = document.querySelector('.ai-search-content');
		if (contentEl) {
			contentEl.addEventListener('wheel', function(e) {
				e.stopPropagation();
			});
		}
	} catch(e) { console.log(e); }
	var modal = document.querySelector('#ai-search-modal');
	if (!modal) return;
	
	if(window.breakpoint <= 2) {
		modal.addEventListener('touchstart', function() {
			document.body.classList.add('hover-ai');
		});
		modal.addEventListener('touchend', function() {
			document.body.classList.remove('hover-ai');
		});
	} else {
		var scrollBarWidth = (window.innerWidth - document.body.clientWidth);
		modal.addEventListener('mouseenter', function() {
			document.body.classList.add('hover-ai');
			document.body.style.paddingRight = scrollBarWidth + 'px';
			var modalEl = document.querySelector('#ai-search-modal');
			var fabEl = document.querySelector('#ai-search-fab');
			// For news article pages, remove the scrollbar-gutter property to prevent content shift when the modal opens
			var scrollbarGutter = document.documentElement.style.getPropertyValue('scrollbar-gutter');
			if(scrollbarGutter) document.documentElement.style.removeProperty('scrollbar-gutter');
			if (modalEl) modalEl.style.marginRight = scrollBarWidth + 'px';
			if (fabEl) fabEl.style.marginRight = scrollBarWidth + 'px';
		});
		modal.addEventListener('mouseleave', function() {
			document.body.classList.remove('hover-ai');
			document.body.removeAttribute('style');
			// Restore the scrollbar-gutter property to prevent content shift when the modal closes
			document.documentElement.style.setProperty('scrollbar-gutter', 'stable');
			var modalEl = document.querySelector('#ai-search-modal');
			var fabEl = document.querySelector('#ai-search-fab');
			if (modalEl) modalEl.removeAttribute('style');
			if (fabEl) fabEl.removeAttribute('style');
		});
	}
}

function bindVpTracking() {
    var modalContent = document.querySelector('.ai-search-content');
	if (!modalContent) return;
	
	var vpHeight = (window.innerHeight * _vars.cfg.vpScrFactor);

var lastVpPos = 0;
var pageIncrement = 1;

modalContent.addEventListener('scroll', function() {
// Skip tracking for automatic/system-triggered scrolling
if(_vars.userScrollNoTrack) {
lastVpPos = modalContent.scrollTop;
return;
} 

var currentOffset = (modalContent.scrollTop - lastVpPos);
var scrolledDown = (currentOffset > 0) ? true: false;

if (Math.abs(currentOffset) > vpHeight) {
		// Use wrapper to set context, call analytics, and remove context for scroll events
		var attrs = shared.getAnalyticsAttributes();
		shared.withAnalyticsContext('scroll', function() {
		// Fire scroll event as virtual pageview WITHOUT PVID refresh
		// First call wmdTrack to set mmodule and mlink, then call wmdPageview
		// On article pages, pass noAdRefresh=true: after a query GenPVID() has changed the PVID,
		// so this scroll pageview would otherwise trigger the host page ad refresh we suppress at msg-sent.
		if (scrolledDown) {
		if (typeof wmdTrack !== 'undefined') {
		wmdTrack('ai-search_scr-dn-' + pageIncrement);
		}
		if (typeof wmdPageview !== 'undefined') {
		wmdPageview('medscape.com/ai-search', pageIncrement, _vars.isArticlePage === true);
		}
		} else {
		if (typeof wmdTrack !== 'undefined') {
		wmdTrack('ai-search_scr-up-' + pageIncrement);
		}
		if (typeof wmdPageview !== 'undefined') {
		wmdPageview('medscape.com/ai-search', pageIncrement, _vars.isArticlePage === true);
		}
		}
		}, {
		queryWordCount: attrs.queryWordCount,
		responseWordCount: attrs.responseWordCount,
		responseTimeFirstToken: attrs.responseTimeFirstToken,
		messageIntent: attrs.messageIntent,
		threadId: attrs.threadId,
		runId: attrs.runId,
		leadConceptId: attrs.leadConceptId,
		queryId: _vars.queryId  // MEDAIS-2052: Include QUERYID in scroll analytics
		});

pageIncrement++;
lastVpPos = modalContent.scrollTop;
}
});

// Reset scroll tracking when new query is submitted
// This ensures scroll measurements start fresh for each query
_vars.resetScrollTracking = function() {
lastVpPos = modalContent.scrollTop;
pageIncrement = 1;
};
}

function handleDrag(container) {
	var startX;
	var scrollLeft;
	var isDragging = false;

	container.addEventListener("mousedown", function(e) {
		isDragging = true;
		_vars.draggedFlag = false;
		container.classList.add("dragging");
		startX = e.pageX - container.offsetLeft;
		scrollLeft = container.scrollLeft;
	});

	container.addEventListener("mousemove", function(e) {
		if (!isDragging) return;
		var x = e.pageX - container.offsetLeft;
		var walk = (x - startX) * 1; // Adjust multiplier for scrolling speed
		if (walk != 0) {
			_vars.draggedFlag = true;
		}
		container.scrollLeft = scrollLeft - walk;
	});

	container.addEventListener("mouseup", function() {
		isDragging = false;
		container.classList.remove("dragging");
		setTimeout(function() { _vars.draggedFlag = false; }, 20);
	});

	container.addEventListener("mouseleave", function() {
		isDragging = false;
		container.classList.remove("dragging");
		setTimeout(function() { _vars.draggedFlag = false; }, 20);
	});

	container.addEventListener("touchstart", function(e) {
		isDragging = true;
		_vars.draggedFlag = false;
		container.classList.add("dragging");
		startX = e.touches[0].pageX - container.offsetLeft;
		scrollLeft = container.scrollLeft;
	});

	container.addEventListener("touchmove", function(e) {
		if (!isDragging) return;
		var x = e.touches[0].pageX - container.offsetLeft;
		var walk = (x - startX) * 1; // Adjust multiplier for scrolling speed
		if (walk != 0) {
			_vars.draggedFlag = true;
		}
		container.scrollLeft = scrollLeft - walk;
	});

	container.addEventListener("touchend", function() {
		isDragging = false;
		container.classList.remove("dragging");
		setTimeout(function() { _vars.draggedFlag = false; }, 20);
	});

	container.addEventListener("touchcancel", function() {
		isDragging = false;
		container.classList.remove("dragging");
		setTimeout(function() { _vars.draggedFlag = false; }, 20);
	});
}

function handleNewSearch() {
	document.querySelector('.ai-search-new').classList.remove('active');
	
    document.querySelector('.ai-search-instructions').classList.add('active');
    document.querySelector('#ai-search-input-modal').placeholder = 'Ask anything';
	
	document.querySelector('.ai-search-content .ai-search-prompts').classList.remove('active');
	
	document.querySelector('#ai-search-modal').classList.remove('prompts-on');
	
	// If pending search timing out, stop it before doing new one
	if (document.querySelector('.ai-search-stop').classList.contains('active')) {
		shared.handleStopGenerate();
	}

	if(_vars.provider === 'dify') {
		_vars.conversationId = '';
	}
	
		// Reset all analytics attributes for new conversation
	shared.resetAnalyticsAttributes();

	// Reset scroll tracking
	if (_vars.resetScrollTracking && typeof _vars.resetScrollTracking === 'function') {
	_vars.resetScrollTracking();
	}
	shared.scrollToBottom();
	
}

// Resolve and store the A2A article context for the current feed article.
// URL source: prefer the passed wrapper's data-contenturl (deep-dive = the clicked article,
// FAB = the in-view article — the exact article the user acted on), then fall back to
// currSlctCont (the feed's current-article URL, which can lag behind asynchronously).
// infMetaRespObj[url] holds that article's full metadata; we read the guid, title and content
// type from the per-article aspen articleData (a2a.aspenData.articleStore.articleData), falling
// back to pageSegVars, and finally to the guid parsed from the URL token — so we never keep a
// stale context or fall through to the entry article's PageMetadata. Resets the thread on change.
//
// isFallback marks the blind capture shared.handleSearch performs for search paths that never
// went through a click listener here (the Vue deep-dive links call window.aiQueryHandleSearch
// directly). That pass has no wrapper to work from, so it must never overwrite a capture an
// explicit caller already made for this same query — PROFCORE-34511: the deep-dive listener
// captured the clicked article, then handleSearch's fallback re-resolved it from the lagging
// currSlctCont and replaced it with the PREVIOUS article, which is what the API then received.
function captureA2AArticleContext(infWrapper, isFallback) {
	if (typeof mscpA2A === 'undefined' || mscpA2A !== true) return;

	if (isFallback) {
		// An explicit caller (deep-dive button/pill, FAB) already resolved the article for this
		// query. api.js clears a2aArticleContext once it is consumed, so a non-null value here
		// always means "captured for the query that is about to be dispatched".
		if (_vars.a2aArticleContext) return;
		// Follow-up typed into an open conversation: stay on the established article so the
		// thread is not reset mid-conversation. The modal covers the feed, which also makes any
		// viewport-based guess meaningless here.
		if (_vars.a2aCurrentArticleGuid && document.body.classList.contains('show-ai-search-modal')) return;
		// Otherwise the in-view feed article is the best available proxy for what the user acted on.
		infWrapper = infWrapper || getInViewInfWrapper();
	}

	var wrapperUrl = infWrapper ? infWrapper.getAttribute('data-contenturl') : '';
	var url = wrapperUrl || (typeof currSlctCont !== 'undefined' ? currSlctCont : '');
	if (!url) return;

	var meta = (typeof infMetaRespObj !== 'undefined' && infMetaRespObj[url]) ? infMetaRespObj[url] : null;
	var articleData = (meta && meta.a2a && meta.a2a.aspenData && meta.a2a.aspenData.articleStore)
		? meta.a2a.aspenData.articleStore.articleData
		: null;
	var segVars = meta ? meta.pageSegVars : null;

	// Guid: aspen article_guid -> pageSegVars (cmsid==2 => asset guid) -> URL trailing token.
	var artId = (articleData && articleData.article_guid) || '';
	if (!artId && segVars) {
		artId = Number(segVars.cmsid) == 2
			? segVars.asst
			: (segVars.art ? String(segVars.art).replace(/\D/g, '') : '');
	}
	if (!artId) {
		var seg = url.split('?')[0].split('#')[0].replace(/\/+$/, '');
		seg = seg.substring(seg.lastIndexOf('/') + 1).split('_')[0];
		var toks = seg.split('-');
		artId = toks[toks.length - 1];
	}
	if (!artId) return;

	var title = (articleData && articleData.formatted_title) || (meta && meta.pageTitle) || document.title;
	var ctype = (articleData && articleData.content_type_external_id)
		? String(articleData.content_type_external_id)
		: (segVars ? String(segVars.ctype || '') : '');

	// Reset the thread only when the article actually changes. Compare against a persistent
	// tracker — NOT _vars.a2aArticleContext, which api.js clears after each query — so repeated
	// queries on the SAME article keep the same conversation/thread_id instead of resetting it.
	if (artId !== _vars.a2aCurrentArticleGuid) {
		if (_vars.provider === 'dify') {
			_vars.conversationId = '';
		}
		// Invalidate any stream still running for the article we just left. Closing the layer does
		// not abort the fetch, so that stream would otherwise keep rendering into the new article's
		// answer block and write its own thread_id back over the reset above (PROFCORE-34511).
		_vars.a2aStreamGeneration++;
		// Reset analytics attributes including threadId to ensure fresh tracking
		shared.resetAnalyticsAttributes();
	}
	_vars.a2aCurrentArticleGuid = artId;

	_vars.a2aArticleContext = {
		article_guid: artId,
		article_title: title,
		content_type_guid: ctype
	};
}

// Expose to shared.handleSearch so any A2A-triggered search (incl. the Vue deep-dive links,
// which call window.aiQueryHandleSearch directly) captures the current article before streaming.
_vars.captureA2AArticleContext = captureA2AArticleContext;

// Find the feed article (.inf-art-wrap) currently occupying the most of the viewport,
// so a FAB-initiated search targets the article the user is actually reading.
function getInViewInfWrapper() {
	var wrappers = document.querySelectorAll('.inf-art-wrap');
	if (!wrappers.length) return null;
	var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	var best = null;
	var bestVisible = 0;
	for (var i = 0; i < wrappers.length; i++) {
		var rect = wrappers[i].getBoundingClientRect();
		var visible = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
		if (visible > bestVisible) {
			bestVisible = visible;
			best = wrappers[i];
		}
	}
	return best;
}

// On A2A feeds the FAB is position:fixed (so it stays visible while the reader scrolls through
// the sibling .inf-art-wrap feed articles, past the sticky #ai-content-wrapper). Fixed strips it
// out of the content column, so re-align it to the column's right edge to match the entry
// article's placement. The reference is #ai-content-wrapper - the FAB's own parent, which is
// exactly the column-width box that positions the entry FAB (absolute; right: 2px inside it).
// #main-container is NOT used: the injection treats it as optional (falls back to articleContainer),
// so it may be absent, whereas the wrapper always exists whenever the FAB does.
//
// The offset is stored as the CSS var --ai-fab-right on <html>, NOT as an inline style on the FAB:
// closeLayer() and the modal mouseleave handler call fab.removeAttribute('style'), which would wipe
// an inline right and leave the FAB stuck at the CSS fallback (right: 16px, viewport edge). A var on
// <html> survives those wipes. The wrapper's horizontal edge is scroll-invariant, so this only needs
// to run on load and resize. Desktop only - mobile keeps its own viewport-edge fixed placement.
function alignFeedFabToColumn() {
	var isA2A = (typeof mscpA2A !== 'undefined' && mscpA2A === true);
	if (!isA2A) return;
	// Mobile keeps the CSS viewport-edge placement; the desktop-only @media rule ignores the var.
	if (window.breakpoint == 1) return;
	var fab = document.getElementById('ai-search-fab');
	var wrapper = fab ? fab.parentElement : null; // #ai-content-wrapper (the article content column)
	if (!wrapper) return;

	// Match the entry article: FAB right edge sits 2px inside the content column's right edge.
	var columnRight = wrapper.getBoundingClientRect().right;
	if (!columnRight) return; // not laid out yet - a later load/resize/rAF pass will set it
	document.documentElement.style.setProperty('--ai-fab-right', Math.max(0, window.innerWidth - columnRight + 2) + 'px');
}

function handleFab() {
	// On A2A feeds, target the article currently in view so a FAB-initiated search uses
	// the right article context (deep-dive instead uses the clicked button's wrapper).
	captureA2AArticleContext(getInViewInfWrapper());

	var progressEl = document.querySelector('.ai-search-progress');
	var stopBtnEl = document.querySelector('.ai-search-stop-btn-dify');
	// Detect an existing/in-progress conversation (e.g. opened earlier via deep dive).
	// Such content only fits the full (maximized) layout, so the FAB must never drop it into the minimized box.
	var hasActiveContent = !!document.querySelector('.ai-search-answer.active')
		|| !!document.querySelector('.ai-gate-content.active')
		|| (progressEl && progressEl.classList.contains('active'))
		|| (stopBtnEl && stopBtnEl.classList.contains('active'));

	if (_vars.isArticlePage) {
		// Article pages only: the FAB and deep dive share the same modal, so a prior deep dive can
		// leave the body maximized. Reopen maximized rather than mixing both state classes (which
		// produced the broken narrow layout).
		if (hasActiveContent || document.body.classList.contains('ai-search-modal-maximized')) {
			document.body.classList.remove('ai-search-modal-minimized');
			document.body.classList.add('ai-search-modal-maximized');
		} else if (!document.body.classList.contains('show-ai-search-modal')) {
			// Fresh entry from the FAB - open the compact minimized search.
			document.body.classList.add('ai-search-modal-minimized');
		}
	} else {
		// Original behavior for all other pages.
		if (!document.body.classList.contains('show-ai-search-modal') && !document.body.classList.contains('ai-search-modal-minimized')) {
			document.body.classList.add('ai-search-modal-minimized');
		}
		if (hasActiveContent && !document.body.classList.contains('ai-search-modal-maximized')) {
			document.body.classList.add('ai-search-modal-maximized');
		}
	}
	// Show Layer
	if(!document.body.classList.contains('show-ai-search-modal')) {
		var fabEl = document.getElementById('ai-search-fab');
		if (fabEl) {
			fabEl.classList.remove('active');
			// Only use display:none on article pages where class removal alone doesn't hide the FAB
			if (_vars.isArticlePage) {
				fabEl.style.display = 'none';
			}
		}
		document.body.classList.add('show-ai-search-modal');

		// For regular article pages, hide the sticky input wrapper when modal opens
		if (_vars.isArticlePage) {
			var articleSearchWrapper = document.querySelector('.article-search-wrapper');
			if (articleSearchWrapper) {
				articleSearchWrapper.style.display = 'none';
			}
		}

		// Add slide-up animation for article pages
		if (_vars.isArticlePage) {
			var modal = document.querySelector('#ai-search-modal');
			if (modal) {
				modal.classList.add('slide-up-enter');
				
				// Remove animation class after animation completes
				setTimeout(function() {
					modal.classList.remove('slide-up-enter');
				}, 400);
			} 
		}


		if (!_vars.ranOnce) {
			// Show prompts (deep dive for article pages, hardcoded for others)
			var promptsEl = document.querySelector('.ai-search-content .ai-search-prompts');
			if (promptsEl) promptsEl.classList.add('active');
		} else {
			var promptsEl = document.querySelector('.ai-search-content .ai-search-prompts');
			var modalInput = document.querySelector('#ai-search-input-modal');
			var modalEl = document.querySelector('#ai-search-modal');
			if (promptsEl) promptsEl.classList.remove('active');
			if (modalInput) modalInput.disabled = false;
			if (modalEl) modalEl.classList.remove('prompts-on');
			shared.scrollToBottom();
		}
	}
}

function sendDislikeEvent(reason, targetElement) {
	// If targetElement is provided, use it; otherwise fall back to last element (for backward compatibility)
	if (targetElement) {
		targetElement.classList.add('selected');
	} else {
		var dislikeEls = document.querySelectorAll('.ai-search-dislike');
		dislikeEls[dislikeEls.length-1].classList.add('selected');
	}
	var eventData = {
		"eventProperties": 
		{
			"likeStatus": reason ? 'dislike:'+reason : 'dislike'
		}
	}
	difyApi.sendEvent(eventData);
}

function createCustomScrollbar(textarea) {
	// Check if scrollbar already exists
	const existingScrollbar = textarea.parentNode.querySelector('.custom-scrollbar');
	if (existingScrollbar) {
		// Return existing scrollbar with update function
		return {
			updateScrollbar: function() {
				updateScrollbarForTextarea(textarea, existingScrollbar);
			},
			scrollbarContainer: existingScrollbar
		};
	}
	
	// Remove existing custom scrollbar if any
	const scrollbarContainers = textarea.parentNode.querySelectorAll('.custom-scrollbar');
	scrollbarContainers.forEach(function(scrollbarContainer) {
		scrollbarContainer.remove();
	});
	
	// Check if it's full-width or modal version
	const isFullWidth = document.querySelector('.ai-search-full-width-container');
	const isMobile = window.innerWidth <= 768;
	
	// Calculate positioning based on context
	let rightPosition, topPosition;
	
	if (isFullWidth) {
		rightPosition = isMobile ? 20 : 20;
		topPosition = isMobile ? 16 : 16;
	} else {
		rightPosition = 14;
		topPosition = 10;
	}
	
	// Create custom scrollbar container
	const scrollbarContainer = document.createElement('div');
	scrollbarContainer.className = 'custom-scrollbar';
	scrollbarContainer.style.cssText = `
		position: absolute;
		right: ${rightPosition}px;
		top: ${topPosition}px;
		bottom: 53px;
		width: 4px;
		background: transparent;
		border-radius: 4px;
		pointer-events: auto;
		z-index: 2;
		opacity: 0;
		transition: opacity 0.2s ease;
	`;
	
	// Create scrollbar thumb
	const scrollbarThumb = document.createElement('div');
	scrollbarThumb.className = 'custom-scrollbar-thumb';
	scrollbarThumb.style.cssText = `
		width: 4px;
		background: #C5CED3;
		border-radius: 4px;
		position: absolute;
		top: 0;
		transition: opacity 0.2s ease;
		min-height: 20px;
		cursor: pointer;
	`;
	
	scrollbarContainer.appendChild(scrollbarThumb);
	textarea.parentNode.appendChild(scrollbarContainer);
	
	// Drag functionality variables
	let isDragging = false;
	let startY = 0;
	let startScrollTop = 0;
	
	// Update scrollbar thumb position and size
	function updateScrollbar() {
		updateScrollbarForTextarea(textarea, scrollbarContainer);
	}
	
	// Handle scrollbar dragging
	function handleScrollbarDrag(e) {
		e.preventDefault();
		const rect = scrollbarContainer.getBoundingClientRect();
		const availableTrackHeight = scrollbarContainer.clientHeight;
		const thumbHeight = parseInt(scrollbarThumb.style.height);
		
		let clientY;
		if (e.type.includes('touch')) {
			clientY = e.touches[0].clientY;
		} else {
			clientY = e.clientY;
		}
		
		const clickY = clientY - rect.top;
		const maxThumbTop = availableTrackHeight - thumbHeight;
		const thumbTop = Math.max(0, Math.min(clickY - thumbHeight / 2, maxThumbTop));
		
		// Calculate scroll position
		const scrollRatio = thumbTop / (availableTrackHeight - thumbHeight);
		const maxScrollTop = textarea.scrollHeight - textarea.clientHeight;
		textarea.scrollTop = scrollRatio * maxScrollTop;
		
		updateScrollbar();
	}
	
	// Mouse events for scrollbar thumb
	scrollbarThumb.addEventListener('mousedown', function(e) {
		e.preventDefault();
		isDragging = true;
		startY = e.clientY;
		startScrollTop = textarea.scrollTop;
		scrollbarThumb.style.background = '#A0A0A0'; // Darker color when dragging
		
		document.addEventListener('mousemove', onMouseMove);
		document.addEventListener('mouseup', onMouseUp);
	});
	
	function onMouseMove(e) {
		if (!isDragging) return;
		e.preventDefault();
		
		const deltaY = e.clientY - startY;
		const scrollbarHeight = scrollbarContainer.clientHeight;
		const thumbHeight = parseInt(scrollbarThumb.style.height);
		const maxScrollTop = textarea.scrollHeight - textarea.clientHeight;
		const scrollRatio = deltaY / (scrollbarHeight - thumbHeight);
		
		textarea.scrollTop = startScrollTop + (scrollRatio * maxScrollTop);
		updateScrollbar();
	}
	
	function onMouseUp() {
		isDragging = false;
		scrollbarThumb.style.background = '#C5CED3'; // Reset color
		document.removeEventListener('mousemove', onMouseMove);
		document.removeEventListener('mouseup', onMouseUp);
	}
	
	// Touch events for mobile
	scrollbarThumb.addEventListener('touchstart', function(e) {
		e.preventDefault();
		isDragging = true;
		startY = e.touches[0].clientY;
		startScrollTop = textarea.scrollTop;
		scrollbarThumb.style.background = '#A0A0A0';
		
		document.addEventListener('touchmove', onTouchMove, { passive: false });
		document.addEventListener('touchend', onTouchEnd);
	});
	
	function onTouchMove(e) {
		if (!isDragging) return;
		e.preventDefault();
		
		const deltaY = e.touches[0].clientY - startY;
		const scrollbarHeight = scrollbarContainer.clientHeight;
		const thumbHeight = parseInt(scrollbarThumb.style.height);
		const maxScrollTop = textarea.scrollHeight - textarea.clientHeight;
		const scrollRatio = deltaY / (scrollbarHeight - thumbHeight);
		
		textarea.scrollTop = startScrollTop + (scrollRatio * maxScrollTop);
		updateScrollbar();
	}
	
	function onTouchEnd() {
		isDragging = false;
		scrollbarThumb.style.background = '#C5CED3';
		document.removeEventListener('touchmove', onTouchMove);
		document.removeEventListener('touchend', onTouchEnd);
	}
	
	// Click on scrollbar track to jump to position
	scrollbarContainer.addEventListener('click', function(e) {
		if (e.target === scrollbarThumb) return; // Don't handle thumb clicks here
		handleScrollbarDrag(e);
	});
	
	// Bind scroll event
	textarea.addEventListener('scroll', updateScrollbar);
	
	// Handle window resize
	window.addEventListener('resize', function() {
		setTimeout(updateScrollbar, 100);
	});
	
	// Initial update
	setTimeout(updateScrollbar, 0);
	
	return { updateScrollbar, scrollbarContainer };
}

// Extract scrollbar update logic to a separate function
function updateScrollbarForTextarea(textarea, scrollbarContainer) {
	const scrollbarThumb = scrollbarContainer.querySelector('.custom-scrollbar-thumb');
	if (!scrollbarThumb) return;
	
	const scrollHeight = textarea.scrollHeight;
	const clientHeight = textarea.clientHeight;
	const scrollTop = textarea.scrollTop;
	
	// Only show scrollbar if content is scrollable
	if (scrollHeight <= clientHeight) {
		scrollbarContainer.style.opacity = '0';
		return;
	}
	
	scrollbarContainer.style.opacity = '1';
	
	// Calculate scrollbar track height
	const availableTrackHeight = scrollbarContainer.clientHeight;
	
	// Calculate thumb height proportional to visible content vs total content
	const thumbHeight = Math.max(20, (clientHeight / scrollHeight) * availableTrackHeight);
	
	// Calculate thumb position
	const scrollRatio = scrollTop / (scrollHeight - clientHeight);
	const thumbTop = scrollRatio * (availableTrackHeight - thumbHeight);
	
	scrollbarThumb.style.height = thumbHeight + 'px';
	scrollbarThumb.style.top = Math.max(0, Math.min(thumbTop, availableTrackHeight - thumbHeight)) + 'px';
}

function autoExpandTextarea(textarea) {
	if (!textarea) return;
	
	// Get viewport height for responsive max-height calculation
	const viewportHeight = window.innerHeight;
	const isMobile = window.innerWidth <= 768;
	const isIPad = /iPad|Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
	const isFullWidth = document.querySelector('.ai-search-full-width-container');
	// Define height constraints based on viewport and context
	const minHeight = isFullWidth 
		? (isMobile ? 45 : 58)  // Full-width minimum height
		: (isMobile ? 45 : 46); // Modal version minimum height

	const maxHeight = isFullWidth 
		? (isMobile ? 271 : 329)  // Full-width maximum height
		: (isMobile ? 268 : 268);

	// Calculate submit button reserved space
	const submitButtonSpace = 30;
	
	// Define dead zone based on context
	var deadZone = (isFullWidth && !isMobile) ? 53 : 47;
	
	// Reset to get natural height
	textarea.style.height = 'auto';
	textarea.style.overflowY = 'hidden';
	textarea.style.paddingBottom = ''; // Reset padding bottom
	textarea.classList.remove('scrollable'); // Remove scrollable class
	
	// Get the scroll height (natural content height)
	const scrollHeight = textarea.scrollHeight;
	const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight) || 21;
	
	// Calculate if we need extra space for submit button
	let needsExtraSpace = false;
	let willBeScrollable = false;
	let heightIncreased = false;
	let isMultiline = false;
	
	if (textarea.value && textarea.value.trim() !== '') {
		// Check if height has increased beyond minimum - use a small tolerance
		const heightTolerance = isFullWidth && isMobile ? 5 : 2;
		heightIncreased = scrollHeight > (minHeight + heightTolerance);
		
		// Create a temporary div to measure text layout more accurately
		const tempDiv = createMeasurementDiv(textarea);
		document.body.appendChild(tempDiv);
		
		try {
			// Set the same width constraints as textarea
			const textareaStyle = getComputedStyle(textarea);
			// Use a consistent width calculation that doesn't depend on current padding-right
			// to avoid feedback loops when padding changes
			const paddingLeft = parseFloat(textareaStyle.paddingLeft);
			const baseWidth = textarea.offsetWidth - paddingLeft - 45; // Use default 45px right padding for calculation
			
			tempDiv.style.width = baseWidth + 'px';
			tempDiv.innerHTML = textarea.value.replace(/\n/g, '<br>');
			
			// Check if content extends beyond available width minus submit button space
			const contentHeight = tempDiv.scrollHeight;
			const lines = Math.ceil(contentHeight / lineHeight);
			// More accurate multiline detection
			isMultiline = lines > 1 || textarea.value.includes('\n');
			// Check if content will be scrollable
			willBeScrollable = scrollHeight > maxHeight;
			
			// For full-width mobile, be more strict about when to reserve space
			if (isFullWidth && isMobile) {
				// Only reserve space if we actually have multiple lines or explicit line breaks
				if (isMultiline) {
					needsExtraSpace = true;
				} else {
					// For single line, check if it would wrap with submit button
					tempDiv.style.width = (baseWidth - submitButtonSpace) + 'px';
					const constrainedHeight = tempDiv.scrollHeight;
					const constrainedLines = Math.ceil(constrainedHeight / lineHeight);
					needsExtraSpace = constrainedLines > 1;
					isMultiline = needsExtraSpace;
				}
			} else {
				// Original logic for non-mobile or modal
				if (lines > 1 || heightIncreased) {
					needsExtraSpace = true;
					isMultiline = true;
				} else {
					tempDiv.style.width = (baseWidth - submitButtonSpace) + 'px';
					const constrainedHeight = tempDiv.scrollHeight;
					needsExtraSpace = constrainedHeight > lineHeight;
					isMultiline = needsExtraSpace;
				}
			}
		} finally {
			document.body.removeChild(tempDiv);
		}
	}
	
	// Handle submit button positioning for full-width pages
	if (isFullWidth) {
		const submitButton = document.querySelector('#ai-search-modal-submit');
		const stopButton = document.querySelector('.ai-search-stop-btn-dify');
		
		if (submitButton) {
			if (isMultiline) {
				submitButton.classList.add('multiline');
			} else {
				submitButton.classList.remove('multiline');
			}
		}
		
		if (stopButton) {
			if (isMultiline || heightIncreased) {
				stopButton.classList.add('multiline');
			} else {
				stopButton.classList.remove('multiline');
			}
		}
	}
	
	// Calculate required height
	let newHeight;
	let isScrollable = false;
	if (!textarea.value || textarea.value.trim() === '') {
		// Empty textarea
		newHeight = minHeight;
		textarea.style.overflowY = 'hidden';
		textarea.style.paddingBottom = '';
		
		// Set default padding for empty textarea
		if (isFullWidth) {
			if (isIPad) {
				textarea.style.padding = '16px 45px 16px 20px';
			} else if (isMobile) {
				textarea.style.padding = '10px 45px 10px 20px';
			} else {
				textarea.style.padding = '16px 45px 16px 20px';
			}
			
			const submitButton = document.querySelector('#ai-search-modal-submit');
			const stopButton = document.querySelector('.ai-search-stop-btn-dify');
			
			if (submitButton) {
				submitButton.style.top = '50%';
				submitButton.style.transform = 'translateY(-50%)';
			}
			
			if (stopButton) {
				stopButton.classList.remove('multiline');
			}
		} else {
			// Modal version - apply default 45px right padding for empty textarea
			const currentPadding = getComputedStyle(textarea);
			const paddingTop = currentPadding.paddingTop;
			const paddingBottom = currentPadding.paddingBottom;
			const paddingLeft = currentPadding.paddingLeft;
			textarea.style.padding = `${paddingTop} 45px ${paddingBottom} ${paddingLeft}`;
		}
	} else {
		// Calculate base height
		let requiredHeight = scrollHeight;
		
		// Add extra line height if needed for submit button space (for non-scrollable content)
		if (needsExtraSpace && !willBeScrollable) {
			requiredHeight += lineHeight;
			requiredHeight += 12; // Add extra space for submit button
		}
		if (requiredHeight <= maxHeight && !willBeScrollable) {
			// Content fits within max height and won't be scrollable
			newHeight = Math.max(requiredHeight, minHeight);
			textarea.style.overflowY = 'hidden';
			isScrollable = false;
			
			// Set default padding for non-scrollable textarea
			if (isFullWidth) {
				const paddingRight = !isMultiline ? '45px' : '20px';
				if (isIPad) {
					textarea.style.padding = `16px ${paddingRight} 16px 20px`;
				} else if (isMobile) {
					textarea.style.padding = `10px ${paddingRight} 10px 20px`;
				} else {
					textarea.style.padding = `16px ${paddingRight} 16px 20px`;
				}
			} else {
				// Modal version - apply conditional padding logic
				const paddingRight = !isMultiline ? '25px' : '20px';
				const currentPadding = getComputedStyle(textarea);
				const paddingTop = currentPadding.paddingTop;
				const paddingBottom = currentPadding.paddingBottom;
				const paddingLeft = currentPadding.paddingLeft;
				textarea.style.padding = `${paddingTop} ${paddingRight} ${paddingBottom} ${paddingLeft}`;
			}
			
			// Add padding-bottom when content goes to second line or height increases
			if (needsExtraSpace || heightIncreased) {
				//commenting below line as this is indidrectly increasing height of textarea,keeping it for reference
				// textarea.style.paddingBottom = deadZone + 'px';
			} else {
				textarea.style.paddingBottom = '';
			}
		} else {
			// Content exceeds max height, will be scrollable
			// KEY CHANGE: Reduce the actual height by dead zone to create non-scrollable area
			newHeight = maxHeight - deadZone;
			textarea.style.overflowY = 'auto';
			isScrollable = true;
			textarea.classList.add('scrollable');
			
			// Set scrollable padding for full-width textarea (keep existing values)
			if (isFullWidth) {
				textarea.style.padding = '16px 36px 16px 20px';
			}
			
			// Don't add padding-bottom for scrollable content - we use height reduction instead
			textarea.style.paddingBottom = '0px';
			
			// Create custom scrollbar
			const scrollbarInfo = createCustomScrollbar(textarea);
			
			// Update scrollbar when content changes
			setTimeout(() => {
				if (scrollbarInfo && scrollbarInfo.updateScrollbar) {
					scrollbarInfo.updateScrollbar();
				}
			}, 0);
		}
	}
	
	// Apply the new height
	textarea.style.height = newHeight + 'px';
	
	// Add dynamic padding-bottom to ai-search-content div based on textarea height
	const aiSearchContent = document.querySelector('.ai-search-content');
	if (aiSearchContent && heightIncreased) {
		const textareaFieldModal = document.querySelector('#ai-search-field-modal');
		if (textareaFieldModal) {
			// Get the actual height of the textarea field container including borders and padding
			let fieldModalHeight = textareaFieldModal.offsetHeight;
			if(!isFullWidth){
				fieldModalHeight+=50
			}
			aiSearchContent.style.paddingBottom = fieldModalHeight + 'px';
		}
	}
	else{
		aiSearchContent.style.paddingBottom = '';
	}

	// Update existing scrollbar instead of creating new one
	if (isScrollable) {
		// Get or create scrollbar
		let scrollbarInfo = textarea._customScrollbar;
		if (!scrollbarInfo) {
			scrollbarInfo = createCustomScrollbar(textarea);
			textarea._customScrollbar = scrollbarInfo; // Store reference
		}
		
		// Update scrollbar when content changes
		setTimeout(() => {
			if (scrollbarInfo && scrollbarInfo.updateScrollbar) {
				scrollbarInfo.updateScrollbar();
			}
		}, 0);
	} else {
		// Hide scrollbar when not needed
		const existingScrollbar = textarea.parentNode.querySelector('.custom-scrollbar');
		if (existingScrollbar) {
			existingScrollbar.style.opacity = '0';
		}
	}
}

// Helper function to create a measurement div that mimics textarea styling
function createMeasurementDiv(textarea) {
	const div = document.createElement('div');
	const textareaStyle = getComputedStyle(textarea);
	
	// Copy relevant styles from textarea
	div.style.position = 'absolute';
	div.style.top = '-9999px';
	div.style.left = '-9999px';
	div.style.visibility = 'hidden';
	div.style.fontSize = textareaStyle.fontSize;
	div.style.fontFamily = textareaStyle.fontFamily;
	div.style.fontWeight = textareaStyle.fontWeight;
	div.style.lineHeight = textareaStyle.lineHeight;
	div.style.letterSpacing = textareaStyle.letterSpacing;
	div.style.wordSpacing = textareaStyle.wordSpacing;
	div.style.whiteSpace = 'pre-wrap';
	div.style.wordWrap = 'break-word';
	div.style.overflow = 'hidden';
	
	return div;
}

function initAutoExpandTextarea() {
	const textarea = document.querySelector('#ai-search-input-modal');
	if (!textarea) return;
	
	// Initial setup
	autoExpandTextarea(textarea);
	
	// Handle input events with immediate feedback
	textarea.addEventListener('input', function() {
		autoExpandTextarea(this);
	});
	
	// Handle paste events with auto-scroll
	textarea.addEventListener('paste', function() {
		const self = this;
		setTimeout(function() {
			autoExpandTextarea(self);
			// Ensure scroll to bottom after paste
			setTimeout(function() {
				self.scrollTop = self.scrollHeight;
			}, 0);
		}, 0);
	});
	
	// Handle keydown for height adjustment - REMOVED auto-scroll
	textarea.addEventListener('keydown', function(e) {
		const self = this;
		// Prevent Enter key when textarea is empty
		if (e.key === 'Enter' && this.value.trim() === '') {
			e.preventDefault();
			return false;
		}
		// Only handle keys that change content, but not Enter
		if (e.key === 'Backspace' || e.key === 'Delete') {
			setTimeout(function() {
				autoExpandTextarea(self);
			}, 0);
		}
	});
	
	// Handle focus - REMOVED auto-scroll
	textarea.addEventListener('focus', function() {
		const self = this;
		setTimeout(function() {
			autoExpandTextarea(self);
		}, 0);
	});
	
	// Watch for programmatic value changes - REMOVED auto-scroll during polling
	let lastValue = textarea.value;
	const checkForChanges = function() {
		if (textarea.value !== lastValue) {
			lastValue = textarea.value;
			autoExpandTextarea(textarea);
		}
	};
	
	// Poll for changes every 200ms (less frequent)
	setInterval(checkForChanges, 200);
	
	// Handle window resize - REMOVED auto-scroll
	let resizeTimeout;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function() {
			if (textarea) {
				autoExpandTextarea(textarea);
			}
		}, 150);
	});
	
	// Improve scroll behavior - prevent event bubbling only when scrollable
	textarea.addEventListener('wheel', function(e) {
		if (this.style.overflowY === 'auto') {
			const atTop = this.scrollTop === 0;
			const atBottom = this.scrollTop >= (this.scrollHeight - this.clientHeight);
			
			if ((e.deltaY < 0 && !atTop) || (e.deltaY > 0 && !atBottom)) {
				e.stopPropagation();
			}
		}
	});
}

function convertInputToTextareaForFullWidth() {
	var inputElement = document.querySelector('#ai-search-input-modal');
	if (inputElement && inputElement.tagName.toLowerCase() === 'input') {
		// Create new textarea element
		var textarea = document.createElement('textarea');
		
		// Copy attributes from input to textarea
		textarea.id = inputElement.id;
		textarea.name = inputElement.name;
		textarea.placeholder = inputElement.placeholder;
		textarea.value = inputElement.value;
		textarea.autocomplete = inputElement.autocomplete;
		textarea.rows = 1;
		
		// Copy classes and other properties
		textarea.className = inputElement.className;
		textarea.disabled = inputElement.disabled;
		
		// Copy styles
		textarea.style.cssText = inputElement.style.cssText;
		
		// Replace input with textarea
		inputElement.parentNode.replaceChild(textarea, inputElement);
		
		return textarea;
	}
	return inputElement;
}

function handleNewChat() {
	if(_vars.pending) {
		return;
	}
    var fullWidthEl = document.querySelector('.ai-search-full-width-container');
    if (fullWidthEl) {
        // Reset UI state
        fullWidthEl.classList.remove('animate');
        fullWidthEl.classList.remove('animate-out');
        fullWidthEl.classList.remove('has-question-rendered');
        fullWidthEl.classList.add('landing-page');
        fullWidthEl.classList.remove('mobile-card-active');
        fullWidthEl.classList.remove('bg-white');
        fullWidthEl.classList.remove('fixed-height');
		fullWidthEl.classList.remove('scrollable-header-layout')
        
        // Reset input state
        var searchEl = document.querySelector('#ai-search-input-modal');
        searchEl.value = '';
        searchEl.disabled = false;
		searchEl.placeholder = 'Ask anything';
		searchEl.focus();
        
        // Reset other UI elements
		if(document.querySelector('.ai-search-more')) {
			document.querySelector('.ai-search-more').classList.remove('active');
		}
        document.querySelector('.suggested-container').classList.add('active');
        if(document.querySelector('.history-panel')) {
            document.querySelector('.history-panel').classList.remove('active');
			document.querySelector('.history_btn').style.display = 'flex';
        }
        
        // Clear existing conversation
        document.querySelectorAll('.ai-search-content .ai-search-question, .ai-search-content .ai-search-answer, .ai-search-content .ai-search-asking-question').forEach(function(el) {
            el.remove();
        });
        
        // Clean up all persistent ads
        ads.cleanupAllAds();

        // Reset conversation ID if using Dify provider
        if(_vars.provider === 'dify') {
            _vars.conversationId = '';
        }
        
        // Track analytics
        wmdPageLink('ai-search_new-conv', this);
    }
}

function handleArticleSearchClose() {
var articleFab = document.querySelector('#article-ai-search-fab');
if (articleFab) {
    var wrapper = articleFab.querySelector('.article-search-wrapper');
    var sparkle = articleFab.querySelector('.article-search-sparkle');
    
    if (wrapper && sparkle) {
        // Hide the input wrapper with slide down animation
        wrapper.classList.add('hide');
        
        setTimeout(function() {
            wrapper.style.display = 'none';
            wrapper.classList.remove('hide');
            
            // Show the sparkle icon with animation
            sparkle.style.display = 'flex';
            sparkle.classList.add('show');
            
            setTimeout(function() {
                sparkle.classList.remove('show');
            }, 400);
        }, 300);

        // Track close action
        wmdPageLink('ai-search_close-ai-input');
    }
}
}

function handleArticleSearchRestore() {
var articleFab = document.querySelector('#article-ai-search-fab');
if (articleFab) {
    var wrapper = articleFab.querySelector('.article-search-wrapper');
    var sparkle = articleFab.querySelector('.article-search-sparkle');
    
    if (wrapper && sparkle) {
        // Hide the sparkle icon
        sparkle.classList.add('hide');
        
        setTimeout(function() {
            sparkle.style.display = 'none';
            sparkle.classList.remove('hide');
            
            // Show the input wrapper with slide up animation
            wrapper.style.display = 'flex';
            wrapper.classList.add('show');
            
            setTimeout(function() {
                wrapper.classList.remove('show');
            }, 400);
        }, 200);

        // Track open action
        wmdPageLink('ai-search_open-ai-input');
    }
}
}

function handleArticleSearch(event) {
	// Handle article search input - similar to regular search but from article input
	var input = document.querySelector('#article-search-bar');
	if (!input) return;

	var query = '';
	if (event.type === 'keyup' && event.keyCode === 13) {
		query = input.value.trim();
	} else if (event.type === 'click' || event.type === 'mouseup') {
		query = input.value.trim();
	}

	if (query) {
		// For regular article pages, hide the sticky input wrapper and open modal
		if (_vars.isArticlePage) {
			var articleSearchWrapper = document.querySelector('.article-search-wrapper');
			if (articleSearchWrapper) {
				articleSearchWrapper.style.display = 'none';
			}
		}
				// Open the AI search modal first
		if (!document.body.classList.contains('show-ai-search-modal')) {
			document.body.classList.add('show-ai-search-modal');
			// Hide the FAB when modal opens
			var fabEl = document.getElementById('ai-search-fab');
			if (fabEl) {
				fabEl.classList.remove('active');
			}
		}
		
		// Transfer the query to the modal input
		var modalInput = document.querySelector('#ai-search-input-modal');
		if (modalInput) {
			modalInput.value = query;
		}
		
		// Wait a brief moment for modal to be fully rendered, then trigger the search
		setTimeout(function() {
			// Create a simulated event for the modal input to trigger the search
			var simulatedEvent = {
				target: modalInput,
				type: 'keyup',
				key: 'Enter',
				keyCode: 13
			};
			shared.handleSearch(event);
		}, 500);

	}
}

function initFabStickyAdPositioning(retryCount = 0) {
    const fab = document.querySelector('#article-ai-search-fab');
    const ad = document.querySelector('.adhesive-footer-wrapper');
    
    if (!fab || !ad) {
        // Stop retrying after 5 seconds (50 attempts × 100ms)
        if (retryCount < 50) {
            setTimeout(() => initFabStickyAdPositioning(retryCount + 1), 100);
        }
        return;
    }
    
    // Check if ad is hidden by transform
    function isAdHidden() {
        const transform = getComputedStyle(ad).transform || '';
        const adHeight = ad.getBoundingClientRect().height;
        
        // If ad has no height, consider it hidden (not loaded or not visible)
        if (adHeight === 0) {
            return true;
        }
        
        // Check for matrix transform pattern
        const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
        if (matrixMatch) {
            const values = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
            if (values.length >= 6) {
                const translateY = values[5]; // Y translation value
                const isHidden = Math.abs(translateY) >= adHeight * 0.9;
                return isHidden;
            }
        }
        
        // Also check for direct translateY(100%) pattern
        const directTransform = /(translate(3d)?\([^)]*100%)/i.test(transform);
        return directTransform;
    }
    
    // Update FAB position based on ad visibility
    function updateFabPosition() {
        const wrapper = fab.querySelector('.article-search-wrapper');
        const sparkle = fab.querySelector('.article-search-sparkle');
        if (!wrapper) return;
        
        const isHidden = isAdHidden();
        const shouldRaise = !isHidden; // FAB raised when ad is visible        
        
        // Apply fab--raised class to both wrapper and sparkle
        wrapper.classList.toggle('fab--raised', shouldRaise);
        if (sparkle) {
            sparkle.classList.toggle('fab--raised', shouldRaise);
        }
    }
    
    // Set initial state
    updateFabPosition();
    
    // Watch for style changes on the ad element
    const observer = new MutationObserver((mutations) => {
        updateFabPosition();
    });
    
    observer.observe(ad, {
        attributes: true,
        attributeFilter: ['style']
    });
    
    // Backup: Also listen for transition/animation events
    ad.addEventListener('transitionend', updateFabPosition);
    ad.addEventListener('animationend', updateFabPosition);
    
    // Additional backup: Check on scroll and resize
    window.addEventListener('scroll', updateFabPosition, { passive: true });
    window.addEventListener('resize', updateFabPosition, { passive: true });
}

// getBoundingClientRect accounts for transform, so this catches transform-based hiding too.
function isAdhesiveFooterHidden(footer) {
	if (!footer) {
		return true;
	}

	var computedStyle = window.getComputedStyle(footer);
	if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
		return true;
	}

	var rect = footer.getBoundingClientRect();
	return rect.height === 0 || rect.bottom <= 0 || rect.top >= window.innerHeight;
}

// Mobile-only: matches the FAB's bottom offset to the footer's current height + a gap.
function updateFabBottomPositionForMobile() {
	var fab = document.getElementById('ai-search-fab');
	if (!fab) {
		return;
	}

	var isMobile = window.innerWidth <= 767;
	if (!isMobile) {
		fab.style.bottom = '';
		return;
	}

	var adhesiveFooter = document.querySelector('.adhesive-footer-wrapper');
	if (isAdhesiveFooterHidden(adhesiveFooter)) {
		fab.style.bottom = '20px';
		return;
	}

	var footerHeight = adhesiveFooter.getBoundingClientRect().height;
	fab.style.bottom = (footerHeight + 20) + 'px';
}

// Repositions the FAB as soon as the footer's height changes (e.g. its ad loads in).
function observeAdhesiveFooterSize(footer) {
	if (window.ResizeObserver && !footer._aiSearchFabResizeObserved) {
		new ResizeObserver(updateFabBottomPositionForMobile).observe(footer);
		footer._aiSearchFabResizeObserved = true;
	}

	// Catches transform/visibility toggles too, which don't change the footer's box size.
	if (!footer._aiSearchFabAttrsObserved) {
		new MutationObserver(updateFabBottomPositionForMobile)
			.observe(footer, { attributes: true, attributeFilter: ['style', 'class'] });
		footer._aiSearchFabAttrsObserved = true;
	}

	updateFabBottomPositionForMobile();
}

// Waits for the adhesive footer to be inserted into the DOM if it isn't there yet.
function watchAdhesiveFooterForFab() {
	var adhesiveFooter = document.querySelector('.adhesive-footer-wrapper');
	if (adhesiveFooter) {
		observeAdhesiveFooterSize(adhesiveFooter);
		return;
	}

	// Avoid stacking up duplicate observers if bindUI() re-runs before it appears.
	if (window._aiSearchFabDomObserverPending) {
		return;
	}
	window._aiSearchFabDomObserverPending = true;

	var domObserver = new MutationObserver(function() {
		var footer = document.querySelector('.adhesive-footer-wrapper');
		if (footer) {
			domObserver.disconnect();
			window._aiSearchFabDomObserverPending = false;
			observeAdhesiveFooterSize(footer);
		}
	});
	domObserver.observe(document.body, { childList: true, subtree: true });
}

function bindUI() {

	// Initialize AI gating system
	aiGating.initAIGating(shared);

	if(_vars.isSearchResultsPage) {
		return;
	}

	// Check if input should be disabled due to gating on page load
	if (aiGating.shouldGateAIQuery()) {
		var fullWidthEl = document.querySelector('.ai-search-full-width-container');
		if (fullWidthEl) {
			// Switch to conversation page
			shared.switchToConversationPage(fullWidthEl);
		}
		
		// Disable input fields and show gating banner
		setTimeout(function() {
			var modalInput = document.querySelector('#ai-search-input-modal');
			
			if (modalInput) {
				modalInput.disabled = true;
			}

			if (!_vars.isFullPage) {
				document.body.classList.add('ai-search-modal-maximized');
				document.querySelector('.ai-search-footer').classList.add('inactive');
			}
			
			// Show gating banner
			aiGating.showAIGate();
		}, 100);
	}

	// Initialize delegated rating listeners FIRST (before any buttons are created)
	shared.initDelegatedRatingListeners();

	window.aiSchPageview = aiSchPageview;

	// Detect article pages: either 'viewarticle' in URL or A2A feed pages
	_vars.isArticlePage = window.location.href.includes('viewarticle') || (typeof mscpA2A !== 'undefined' && mscpA2A === true);
	_vars.isArticleMobile = (_vars.isArticlePage && window.breakpoint == 1);

	var fullWidthEl = document.querySelector('.ai-search-full-width-container');

	// Clean up any existing AI search elements before creating new ones
	// This prevents duplicate modals when navigating between articles
	// ONLY do cleanup on non-full-width pages (article pages, condition pages, etc.)
	// Full-width landing page has server-rendered HTML that should not be removed
	if (!fullWidthEl) {
		var existingModal = document.querySelector('#ai-search-modal');
		var existingFab = document.querySelector('#ai-search-fab');
		var existingArticleFab = document.querySelector('#article-ai-search-fab');

		if (existingModal) {
			existingModal.remove();
		}
		if (existingFab) {
			existingFab.remove();
		}
		if (existingArticleFab) {
			existingArticleFab.remove();
		}

		// Reset body classes related to AI search
		document.body.classList.remove('show-ai-search-modal');
		document.body.classList.remove('article-ai-search-active');
		document.body.classList.remove('article-ai-search-anon');
		document.body.classList.remove('regular-article-page');
		document.body.classList.remove('ai-search-modal-maximized');
		document.body.classList.remove('ai-search-modal-minimized');

	// Reset conversation state for new article
		if (_vars.provider === 'dify') {
			_vars.conversationId = '';
		}
		_vars.ranOnce = false;
	}

	// Append the appropriate HTML based on page type
	if(!fullWidthEl) {
	var aiContainElem = document.querySelector(_vars.cfg.prependElem);

		if (_vars.isArticlePage) {
			// For article pages, use body as fallback if prependElem doesn't exist
			var articleContainer = aiContainElem || document.body;

			// For article pages, add AI search modal and FAB button
			articleContainer.insertAdjacentHTML('beforeend', _html.main());
			
			// Replace hardcoded prompts with Deep Dive prompts for article pages
			var promptsEl = document.querySelector('.ai-search-content .ai-search-prompts');
			if (promptsEl) {
				promptsEl.innerHTML = _html.deepDivePrompts(_vars.cfg.deepDiveLinks);
			}
			
			// Add the FAB button wrapper and FAB for article pages.
			// Host the wrapper inside the article content column (#main-container) so the
			// sticky FAB aligns to the column's right edge (per Figma) instead of the
			// viewport edge. Fall back to the article container if the column isn't present.
			var fabHost = document.querySelector('#main-container') || articleContainer;
			var aiFabWrapper = document.querySelector('#ai-content-wrapper');
			if (!aiFabWrapper) {
				fabHost.insertAdjacentHTML('beforeend', `<div id="ai-content-wrapper"></div>`);
				aiFabWrapper = document.querySelector('#ai-content-wrapper');
			}
			aiFabWrapper.insertAdjacentHTML('beforeend', _html.fab());
			
			if (!_vars.isArticleMobile) {
				document.body.classList.add('regular-article-page');
			}

			// Tag A2A infinite-feed pages so the FAB can be pinned into view on desktop.
			// On a feed the sticky #ai-content-wrapper sits below the entire stack of
			// articles, so its absolute-positioned FAB never scrolls into view on desktop.
			if (typeof mscpA2A !== 'undefined' && mscpA2A === true) {
				document.body.classList.add('a2a-feed-page');
				// Keep the fixed FAB aligned to the content column's right edge (matches the
				// entry article) rather than the viewport edge. Run now, after the next layout
				// frame, and on window load so a too-early first pass (before the column is laid
				// out) is always corrected; then keep it aligned across resizes.
				alignFeedFabToColumn();
				window.requestAnimationFrame(alignFeedFabToColumn);
				window.addEventListener('load', alignFeedFabToColumn);
				window.addEventListener('resize', alignFeedFabToColumn, { passive: true });
			}

			document.body.classList.add('article-ai-search-active');

			// Tag anon (logged-out) users so the FAB can be pushed BELOW the header.
			// Anon users get the header variant with `.not-logged` shown, whose sticky bar
			// sits at a low z-index (~1001) — under the FAB's default z-index (1999997) — so
			// the FAB paints over the header on scroll. Logged-in users get a header that
			// stacks above the FAB and must not change. There is no usable anon marker in the
			// DOM/body otherwise: the header toggles `.not-logged` via v-show, so it stays
			// present-but-hidden for logged-in users. Uses the same anon check as elsewhere
			// in this file (authLevel === 0).
			var isAnon = typeof PageMetadata !== 'undefined' && PageMetadata.authVar && Number(PageMetadata.authVar.authLevel) === 0;
			if (isAnon) {
				document.body.classList.add('article-ai-search-anon');
			}
			
			// Initialize FAB as visible (active) for article pages only if modal is not open
			// Must be done AFTER body classes are set to ensure CSS rules apply correctly
			var initialFab = document.getElementById('ai-search-fab');
			if (initialFab && !document.body.classList.contains('show-ai-search-modal')) {
				initialFab.classList.add('active');
			}
		} else {
			// Regular page - show normal AI search
			aiContainElem.insertAdjacentHTML('beforeend', _html.main());
			var aiFabWrapper = aiContainElem.querySelector('#ai-content-wrapper');
			if (!aiFabWrapper) {
				aiContainElem.insertAdjacentHTML('beforeend', `<div id="ai-content-wrapper"></div>`);
				aiFabWrapper = aiContainElem.querySelector('#ai-content-wrapper');
			}
			aiFabWrapper.insertAdjacentHTML('beforeend', _html.fab());
		}
	} else {
		// Convert input to textarea for full-width landing page
		convertInputToTextareaForFullWidth();
	}

	// Initialize auto-expand textarea
	initAutoExpandTextarea();

	// Set focus on search field
	if (fullWidthEl) {
		// For full-width landing page
		var searchEl = document.querySelector('#ai-search-input-modal');
		if (searchEl) {
			searchEl.focus();
		}
	}

	// Questions Dragging
	if (typeof window.ontouchstart == 'undefined') {
		document.querySelectorAll(".prompts-desktop-modal, .prompts-mobile-modal").forEach(handleDrag);
	}

	// Function to detect Android devices
	function isAndroid() {
		return /Android/i.test(navigator.userAgent);
	}

// Bind the Submits - MODIFIED FOR ANDROID HANDLING
var searchSubmitSelectors = '#ai-search-modal-submit, #ai-search-input-modal, .ai-search-prompts span, .ai-search-prompts p';
document.querySelectorAll(searchSubmitSelectors).forEach(function(submitElem) {
    // Special handling for hardcoded prompts that have inline onclick with msg-submit-clkc
    if (submitElem.matches('.ai-search-prompts p')) {
        submitElem.addEventListener('click', function(e) {
			// For article pages (mobile and desktop), open the modal first
			if (_vars.isArticlePage && !document.body.classList.contains('show-ai-search-modal')) {
				document.body.classList.add('show-ai-search-modal');
				// Hide the FAB when modal opens
				var fabEl = document.getElementById('ai-search-fab');
				if (fabEl) {
					fabEl.classList.remove('active');
					fabEl.style.display = 'none';
				}
				// Hide the sticky input wrapper
				var articleSearchWrapper = document.querySelector('.article-search-wrapper');
				if (articleSearchWrapper) {
					articleSearchWrapper.style.display = 'none';
				}
			}
			// For article pages, always remove minimized and add maximized for proper CSS state
			if (_vars.isArticlePage) {
				document.body.classList.remove('ai-search-modal-minimized');
			}
			if (!document.body.classList.contains('ai-search-modal-maximized')) {
				document.body.classList.add('ai-search-modal-maximized');
			}
            // For deep dive prompts, use data-prompt attribute; otherwise use textContent
            var query = this.getAttribute('data-prompt') || this.textContent.trim();
            if (query) {
                // MEDAIS-2052: Generate QUERYID before analytics call
                // This ensures msg-submit-clkc and msg-submit use the same QUERYID
				_vars.isModalPromptClicked = true;
                _vars.queryId = generateQueryId();
                
                // Mark this as an initial prompt click so handleSearch preserves
                // 'Initial prompt' as the querySource for the resulting query.
                // Set querySource before analytics so getMsgSubmitMethod() returns 'initial'
                // for both this msg-submit-clkc call and the msg-submit fired inside handleSearch.
                // isInitialPromptQuery signals handleSearch to preserve 'Initial prompt' as querySource.

                _vars.querySource = 'Initial prompt';
                _vars.isInitialPromptQuery = true;

                // Set query word count and get attributes
                shared.setQueryWordCount(query);
                var attrs = shared.getAnalyticsAttributes();
                
                // Extract the index from the inline onclick to maintain the same mlink
                // Support both regular prompts (msg-submit-clkc) and deep dive prompts (deep-dive-clkc)
                var onclickAttr = this.getAttribute('onclick') || '';
                var isDeepDive = this.classList.contains('deep-dive-prompt');
                var mlinkMatch = isDeepDive 
                    ? onclickAttr.match(/deep-dive-clkc-(\d+)/)
                    : onclickAttr.match(/msg-submit-clkc-(\d+)/);
                var mlinkSuffix = mlinkMatch ? mlinkMatch[1] : '1';
                var mlinkPrefix = isDeepDive ? 'deep-dive-clkc' : 'msg-submit-clkc';
                
                // Use wrapper to set context, call analytics, and remove context
                shared.withAnalyticsContext(mlinkPrefix, function() {
                    // Fire the analytics call that was in the inline onclick
                    if (typeof wmdPageLink !== 'undefined') {
                        wmdPageLink('ai-search_' + mlinkPrefix + '-' + mlinkSuffix, e.target);
                    }
                }, {
                    queryWordCount: attrs.queryWordCount,
                    threadId: attrs.threadId,
                    runId: attrs.runId,
                    leadConceptId: attrs.leadConceptId
                });
                
                // Now trigger the search
                shared.handleSearch(query);
            }
            // Prevent the inline onclick from firing
            e.stopImmediatePropagation();
            return false;
        }, true); // Use capture phase to run before inline onclick
        return; // Skip the rest of the handler setup for this element
    }

		if (submitElem.tagName == 'INPUT' || submitElem.tagName == 'TEXTAREA') {
			// Prevent Enter key behavior when textarea is empty
			if (!document.body.classList.contains('ai-search-modal-maximized')) {
				submitElem.addEventListener('focus', function() {
					document.body.classList.add('ai-search-modal-maximized');
				});
			}
			submitElem.addEventListener('keydown', function(e) {
				if (e.key === 'Enter') {
					var value = this.value.trim();
					if (value === '') {
						e.preventDefault();
						return false;
					}
					
					// Android-specific behavior: Enter key should add new line, not submit
					if (isAndroid() && !e.shiftKey) {
						// Allow default behavior (new line) for Android devices
						return true;
					}
				}
			});
			
			// Handle submission based on device and key combination
			submitElem.addEventListener('keyup', function(e) {
				if (e.key === 'Enter') {
					// Prevent submission if content is empty or only whitespace
					var value = this.value.trim();
					if (value === '') {
						e.preventDefault();
						return;
					}
					
					if (isAndroid()) {
						// On Android: only submit on Shift+Enter
						if (e.shiftKey) {
							shared.handleSearch.call(this, e);
						}
						// Regular Enter adds new line (default behavior)
					} else {
						// On iOS and Desktop: submit on Enter, new line on Shift+Enter
						if (!e.shiftKey) {
							shared.handleSearch.call(this, e);
						}
						// Shift+Enter allows default (insert newline)
					}
				}
			});
		} else {
			if (typeof window.ontouchstart == 'undefined') {
				submitElem.addEventListener('mouseup', function(e) {
					if (!document.body.classList.contains('ai-search-modal-maximized')) {
						document.body.classList.add('ai-search-modal-maximized');
					}
					// For non-input elements, check if we're clicking submit button
					if (this.id === 'ai-search-modal-submit') {
						var textarea = document.querySelector('#ai-search-input-modal');
						if (textarea && textarea.value.trim() === '') {
							e.preventDefault();
							return;
						}
					}
					shared.handleSearch.call(this, e);
				});
			}
			else {
				submitElem.addEventListener('click', function(e) {
					// For non-input elements, check if we're clicking submit button
					if (!document.body.classList.contains('ai-search-modal-maximized')) {
						document.body.classList.add('ai-search-modal-maximized');
					}
					if (this.id === 'ai-search-modal-submit') {
						var textarea = document.querySelector('#ai-search-input-modal');
						if (textarea && textarea.value.trim() === '') {
							e.preventDefault();
							return;
						}
					}
					shared.handleSearch.call(this, e);
				});
			}
		}
	});

if(!fullWidthEl) {
	// Close Layer
	var closeBtn = document.querySelector('.ai-search-header .close-layer');
	if (closeBtn) {
		closeBtn.addEventListener('click', closeLayer);
	}
	// Bind FAB for all pages including article pages
	var fabBtn = document.querySelector('#ai-search-fab');
	if (fabBtn) {
		fabBtn.addEventListener('click', handleFab);
	}
}

// Bind article search functionality if on article page
if (_vars.isArticlePage) {
    var articleSearchBar = document.querySelector('#article-search-bar');
    var articleSearchContainer = document.querySelector('.article-search-container');
    var articleSearchClose = document.querySelector('.article-search-close');
    var articleSparkle = document.querySelector('.article-search-sparkle');
    var articleIconLeft = document.querySelector('.article-search-icon-left');
    var articleIconRight = document.querySelector('.article-search-icon-right');
    
    if (articleSearchBar) {
        articleSearchBar.addEventListener('keyup', handleArticleSearch);
        articleSearchBar.addEventListener('focus', function() {

            // Add focus styling
            var container = this.closest('.article-search-container');
            if (container) {
                container.style.borderColor = 'rgba(6, 74, 167, 0.8)';
            }
            
            // Track focus event
            wmdTrack('ai-search_article-input-focus', this);
        });
        articleSearchBar.addEventListener('blur', function() {
            // Remove focus styling
            var container = this.closest('.article-search-container');
            if (container) {
                container.style.borderColor = 'rgba(6, 74, 167, 0.40)';
            }
        });
        
        // For regular article pages, add input event listener to show/hide send icon
        if (_vars.isArticlePage) {
            articleSearchBar.addEventListener('input', function() {
                var sendIcon = document.querySelector('.article-search-icon-right');
                if (sendIcon) {
                    if (this.value.trim().length > 0) {
                        sendIcon.style.display = 'block';
                    } else {
                        sendIcon.style.display = 'none';
                    }
                }
            });
        }
    }
    
    // Initially hide the send icon for regular article pages
    if (_vars.isArticlePage && articleIconRight) {
        articleIconRight.style.display = 'none';
    }
    
    if (articleSearchContainer) {
        articleSearchContainer.addEventListener('click', function(event) {
            // Only open AI search modal when isA2A is true
            // For regular article pages (isArticlePage), allow normal input functionality
            if (_vars.isArticleMobile && !event.target.closest('.article-search-close')) {
                handleFab();

				if (window.breakpoint == 1) {
					wmdTrack('ai-search_open-from-input-click', event.target); 
					aiSchPageview(0);
				}

                // Focus on modal input after a small delay to ensure modal is open
                setTimeout(function() {
                    var modalInput = document.querySelector('#ai-search-input-modal');
                    if (modalInput) {
                        modalInput.focus();
                    }
                }, 100);                
            } else if (_vars.isArticlePage && !event.target.closest('.article-search-close')) {
                // For regular article pages, focus on the input field when clicking anywhere in container
                if (articleSearchBar) {
                    articleSearchBar.focus();
                }     
            }
        });
    }
    
    if (articleSearchClose) {
        articleSearchClose.addEventListener('click', handleArticleSearchClose);
    }
    
    if (articleSparkle) {
        articleSparkle.addEventListener('click', handleArticleSearchRestore);
    }
    
    if (articleIconLeft) {
        articleIconLeft.addEventListener('click', function() {
            // Only open AI search modal when isA2A is true
            // For regular article pages (isArticlePage), focus on input for normal typing
            if (_vars.isArticleMobile) {
                // Open AI search modal and focus on the input when sparkle icon is clicked
                handleFab();
                if (articleSearchBar) {
                    articleSearchBar.focus();
                }
            } else if (_vars.isArticlePage && articleSearchBar) {
                // For regular article pages, just focus on the input for normal typing
                articleSearchBar.focus();
            }
            // Track click event
            wmdTrack('ai-search_article-sparkle-click', this);
        });
    }
    
    if (articleIconRight) {
        articleIconRight.addEventListener('click', function() {
            // Trigger search when send icon is clicked
            if (articleSearchBar) {
                var query = articleSearchBar.value.trim();
                if (query) {
                    handleArticleSearch({ target: articleSearchBar, type: 'click' });
                } else if (_vars.isArticleMobile) {
                    // If no query and A2A page, open the modal
                    handleFab();
                    articleSearchBar.focus();
                } else if (_vars.isArticlePage) {
                    // For regular article pages, just focus on input for normal typing
                    articleSearchBar.focus();
                }
                // Track click event
                wmdTrack('ai-search_article-send-click', this);
            }
        });
    }
}
	
	
	// Start New Search
	document.querySelector('.ai-search-new-btn span').addEventListener('click', handleNewSearch);
	
    // Stop Generating
    document.querySelector('.ai-search-stop-btn').addEventListener('click', shared.handleStopGenerate);
    document.querySelector('.ai-search-stop-btn-dify').addEventListener('click', shared.handleDifyStopGenerate);

    // Full AI Search Link
    var fullSearchLink = document.querySelector('.full-search-link');
    if (fullSearchLink) {
        fullSearchLink.addEventListener('click', handleFullAISearchClick);
    }

	// View Full Table CTA (rendered dynamically with table content)
    document.addEventListener('click', function(event) {
        var viewFullTableLink = event.target.closest('.view-full-table-cta');
        if (viewFullTableLink) {
            handleViewFullTableClick(event);
        }
    });

    // The full AI search page loads conversation history by conversationId right after
    // navigation, but that history isn't reliably indexed until a few seconds after the
    // stream finishes - so don't consider the conversation linkable until this delay passes.
    window.addEventListener('aiEvtStreamComplete', function() {
        setTimeout(function() {
            isConversationHistoryReady = true;
        }, 5000);
    });

	// Scroll to Bottom - Enhanced touch handling for iPad Safari
	var scrollMoreButton = document.querySelector('.ai-search-more');
	if (scrollMoreButton) {
		// Simple fix: Add both click and touchend events for better iPad Safari responsiveness
		scrollMoreButton.addEventListener('click', function(e) {
			wmdPageLink('ai-search_scroll-down', this);
			shared.scrollToBottom(e);
		});
		scrollMoreButton.addEventListener('touchend', function(e) {
			e.preventDefault();
			wmdPageLink('ai-search_scroll-down', this);
			shared.scrollToBottom(e);
		});
	}

	// Handle input events for both modal and full-width versions
	var searchEl = document.querySelector('#ai-search-input-modal');
	
	searchEl.addEventListener('input', function(){
		var searchSubmitBtn = document.querySelector('#ai-search-modal-submit');
		var searchField = document.querySelector('#ai-search-field-modal');
		if(searchEl.value && searchEl.value.trim() !== '') {
			searchSubmitBtn.classList.add('visible');
			searchField.classList.add('has-content');
		} else {
			searchSubmitBtn.classList.remove('visible');
			searchField.classList.remove('has-content');
		}
	});

	//Handle full width landing page animations
	if(fullWidthEl) {
		handleHistoryEvents();
		var searchEl = document.querySelector('#ai-search-input-modal');

		//Initial Prompts
		var landingPage = document.querySelector('.landing-page');
		if(landingPage) {
			suggested.init();
		}
		
		searchEl.addEventListener('input', function(){
			var searchSubmitBtn = document.querySelector('#ai-search-modal-submit');
			if(searchEl.value && searchEl.value.trim() !== '') {
				searchSubmitBtn.classList.remove('disabled');
			} else {
				searchSubmitBtn.classList.add('disabled');
			}
		})
		
		searchEl.addEventListener('input', function(e) {
			if(!fullWidthEl.classList.contains('landing-page')) {
				return;
			}
			if (this.value.trim() !== '') {
				fullWidthEl.classList.remove('animate-out');
				fullWidthEl.classList.add('animate');
			} else {
				fullWidthEl.classList.add('animate-out');
				fullWidthEl.classList.remove('animate');
			}
		});

		//Handle Context Preservation when full width landing page is opened
		var queryParams = new URLSearchParams(window.location.search);
		var conversationId = queryParams.get('conversationId');
		// Await the result of api.getHistory()
		//generates token as token gets expired when new window is opened
		if(conversationId){
			history.renderHistoryInChatInterface(conversationId);
		}
	// Handle URL parameters for article context and query
	const params = parseUrlParameters();
	if (params.query) {
		// Store article params for API use
		_vars.articleParams = {
			guid: params.article_guid,
			title: params.article_title,
			contentType: params.content_type_guid
		};
		// Mark this as a predefined query from URL
		_vars.isUrlPredefinedQuery = true;

		// Detect if query came from site-search AI Mode button
		// The global header (Launch) adds ?src=site-search when AI Mode is clicked
		var srcParam = new URLSearchParams(window.location.search).get('src');
		if (srcParam === 'site-search') {
			_vars.querySource = 'ai-mode-query';
		}

// For PDQs on full-width pages, set the lead concept from URL in analytics state
// This ensures all analytics calls use the URL value instead of API value
if (_vars.isFullPage) {
    var scgParam = new URLSearchParams(window.location.search).get('scg');
    if (scgParam) {
        var trimmedScg = scgParam.trim();
        // Remove quotes if present
        if ((trimmedScg.startsWith('"') && trimmedScg.endsWith('"')) || 
            (trimmedScg.startsWith("'") && trimmedScg.endsWith("'"))) {
            trimmedScg = trimmedScg.slice(1, -1).trim();
        }
        
        // Validate the scg value
        var isValidScg = trimmedScg !== '' && 
                        trimmedScg.length > 0 &&
                        !/^\s*$/.test(trimmedScg) &&
                        trimmedScg.toLowerCase() !== 'null' && 
                        trimmedScg.toLowerCase() !== 'none' && 
                        trimmedScg.toLowerCase() !== 'undefined' &&
                        trimmedScg !== '0' &&
                        /^\d+$/.test(trimmedScg);
        
        if (isValidScg) {
            // Directly set in analytics state by calling with force flag
            // The analyticsState.leadConceptId will be used by all analytics calls
            shared.setMetricsAttributes({ concept_id: trimmedScg }, true);
            console.log('[PDQ Init] Set lead concept from URL for analytics:', trimmedScg);
        }
    }
}

		shared.handleSearch(stripTags(params.query).trim());
	}
	}
	
	// Feebback drawer other checkbox
	document.querySelector('#otherCheckbox').addEventListener('change', function(){
		var otherText = document.querySelector('#otherText');
		otherText.style.display = this.checked ? 'block' : 'none';
	});

	var checkboxes = document.querySelectorAll('.feedback-option input[type="checkbox"]')

	checkboxes.forEach(function(checkbox){
		checkbox.addEventListener('change', function(e){
			if(this.checked) {
				if(this.value !== 'Other') {
					var otherText = document.querySelector('#otherText');
					otherText.style.display = 'none';
				}
				var that = this;
				checkboxes.forEach(function(cb){
					if(cb !== that) {
						cb.checked = false;
						var cLabel = cb.closest('.feedback-option');
						if(cLabel) {
							cLabel.classList.remove('checked');
						}
					}
				});
			}
			var label = e.target.closest('.feedback-option');
			if(e.target.checked) {
				label.classList.add('checked');
			} else {
				label.classList.remove('checked');
			}
		});
	});

	document.querySelector('#feedbackForm').addEventListener('submit', function(e){
		e.preventDefault();
		var reason = '';
		var optionIndex;
		document.querySelectorAll('input[name="reason"]').forEach(function(el, index) {
			if(el.checked) {
				reason = el.value;
				optionIndex = index+1;
			}
		});
		if(!reason) {
			return;
		}
		var otherTextValue = document.querySelector('#otherText').value;
		if(reason === 'Other') {
			reason = reason + ' ('+otherTextValue+')';
		}
		// Get the currently active dislike button (the one that opened this feedback form)
		var activeDislikeBtn = document.querySelector('.ai-search-dislike.selected');
		sendDislikeEvent(reason, activeDislikeBtn);
		// Pass the form element itself for tracking
		if(typeof wmdPageLink !== 'undefined') {
			wmdPageLink('ai-search_feedback-'+optionIndex, e.target);
		}
		this.style.display = 'none';
		document.querySelectorAll('.feedback-option').forEach(function(el) {
			el.classList.remove('checked');
		});
		shared.toggleDrawer(false);
		var thankYou = document.querySelector('#feedbackSuccessMsg');
		thankYou.style.display = 'block';
		setTimeout(function() {
			thankYou.style.display = 'none';
		}, 2000);
	});

	document.querySelectorAll('.drawer-close-btn').forEach(function(closeEl) {
		closeEl.addEventListener('click', function(e){
			// Get the currently active dislike button
			var activeDislikeBtn = document.querySelector('.ai-search-dislike.selected');
			sendDislikeEvent(null, activeDislikeBtn);
			document.querySelectorAll('.feedback-option').forEach(function(el) {
				el.classList.remove('checked');
			});
			shared.toggleDrawer(false);
		});
	});
	
	//Handle full width landing page animations
	if(fullWidthEl) {
		/*
		var searchEl = document.querySelector('#ai-search-input-modal');
		var rightContainer = document.querySelector('.right');
		searchEl.addEventListener('focus', function(e){
			if(rightContainer.classList.contains('has-question-rendered')) {
				return;
			}
			rightContainer.classList.remove('animate-out');
			rightContainer.classList.add('animate');
		});
		searchEl.addEventListener('blur', function(e){
			if(rightContainer.classList.contains('has-question-rendered')) {
				return;
			}
			rightContainer.classList.remove('animate');
			rightContainer.classList.add('animate-out');
		});
		*/
	}
	
	// Stop background scrolling on Desktop
	if(!fullWidthEl) {
		stopDesktopBgScroll();
		// Adjust pageName when entering / leaving modal on Desktop
		swapPageNamesDesktop();
	}	
	
	// Bind Virtual Page Tracking
	bindVpTracking();

	initDisclaimerUI();

	// Bind New Chat button
	var newChatBtn = document.querySelector('.new_chat_btn');
	if(newChatBtn) {
		newChatBtn.addEventListener('click', handleNewChat);
	}

	// Keep the FAB's bottom offset in sync with the adhesive footer on load/resize/scroll.
	updateFabBottomPositionForMobile();
	watchAdhesiveFooterForFab();
	if (!window._aiSearchFabListenersBound) {
		window.addEventListener('resize', updateFabBottomPositionForMobile, { passive: true });
		window.addEventListener('scroll', updateFabBottomPositionForMobile, { passive: true });
		window._aiSearchFabListenersBound = true;
	}
}
function processMarkdownTables(content) {
    if (!content || typeof content !== 'string') {
        return content;
    }
    
    // First, normalize line breaks - handle various formats
    // Replace <br>, <br/>, <br /> tags with newlines for processing
    var normalizedContent = content
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');
    
    // Split content into lines for easier processing
    var lines = normalizedContent.split('\n');
    var result = [];
    var i = 0;
    
    while (i < lines.length) {
        var line = lines[i].trim();
        
        // Check if this line could be a table header (contains | and has content)
        if (isTableRow(line)) {
            // Check if next line is a separator line (contains dashes and pipes)
            if (i + 1 < lines.length && isTableSeparator(lines[i + 1].trim())) {
                // We found a potential table - collect all table lines
                var tableLines = [];
                tableLines.push(lines[i].trim()); // header
                tableLines.push(lines[i + 1].trim()); // separator
                
                var j = i + 2;
                // Collect all subsequent data rows (lines that look like table rows)
                while (j < lines.length && isTableRow(lines[j].trim())) {
                    tableLines.push(lines[j].trim());
                    j++;
                }
                
                // Only process if we have at least header + separator + 1 data row
                if (tableLines.length >= 3) {
                    var tableHTML = convertMarkdownTableToHTML(tableLines);
                    result.push(tableHTML);
                    i = j; // Move past all table lines
                    continue;
                }
            }
        }
        
        // Not a table line, keep as-is
        result.push(lines[i]);
        i++;
    }
    
    return result.join('\n');
}

function isTableRow(line) {
    if (!line || typeof line !== 'string') return false;
    line = line.trim();
    // A table row should contain at least one pipe and have content
    // It should start with | or have | somewhere in the middle
    return line.includes('|') && line.length > 2;
}

function isTableSeparator(line) {
    if (!line || typeof line !== 'string') return false;
    line = line.trim();
    // A separator line contains pipes and dashes, possibly with colons for alignment
    // Pattern: |---|---|---| or | --- | --- | or |:---:|:---:|
    return /^\|[\s\-:|\s]+\|$/.test(line) || /^[\s\-:|\s]+$/.test(line) && line.includes('|') && line.includes('-');
}

function convertMarkdownTableToHTML(tableLines) {
    if (!tableLines || tableLines.length < 2) {
        return tableLines ? tableLines.join('\n') : '';
    }
    
    var headerLine = tableLines[0];
    var separatorLine = tableLines[1];
    var dataLines = tableLines.slice(2);
    
    // Parse header cells
    var headerCells = parseTableRow(headerLine);
    if (headerCells.length === 0) {
        return tableLines.join('\n');
    }
    
    // Parse alignment from separator line
    var separatorCells = parseTableRow(separatorLine);
    var alignments = separatorCells.map(function(cell) {
        cell = cell.trim();
        if (cell.startsWith(':') && cell.endsWith(':')) return 'center';
        if (cell.endsWith(':')) return 'right';
        return 'left';
    });

	var isAnon = typeof PageMetadata !== 'undefined' && PageMetadata.authVar && Number(PageMetadata.authVar.authLevel) === 0;
	var viewFullTableCTA = isAnon ? '' : '<div class="view-full-table-cta-wrapper">' +
		'<button class="view-full-table-cta" type="button" aria-label="View full table in full AI search">' +
			'<span>View Full Table</span>' +
			'<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
				'<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.875C0 0.391752 0.39175 0 0.875 0H4.8125C5.05412 0 5.25 0.195875 5.25 0.4375C5.25 0.679125 5.05412 0.875 4.8125 0.875L0.875 0.875V13.125H13.125V9.1875C13.125 8.94588 13.3209 8.75 13.5625 8.75C13.8041 8.75 14 8.94588 14 9.1875V13.125C14 13.6082 13.6082 14 13.125 14H0.875C0.391751 14 0 13.6082 0 13.125V0.875ZM7.43752 0.4375C7.43752 0.195875 7.63339 0 7.87502 0H13.5625C13.8041 0 14 0.195875 14 0.4375V6.12502C14 6.36664 13.8041 6.56252 13.5625 6.56252C13.3209 6.56252 13.125 6.36664 13.125 6.12502V1.49372L5.12186 9.49686C4.951 9.66771 4.674 9.66771 4.50314 9.49686C4.33229 9.326 4.33229 9.049 4.50314 8.87814L12.5063 0.875H7.87502C7.63339 0.875 7.43752 0.679125 7.43752 0.4375Z" fill="#064AA7"/>' +
			'</svg>' +
		'</button>' +
		'</div>';
    
    // Build HTML table
    var tableHTML = viewFullTableCTA + '<div class="table-container"><table role="table">';
    
    // Add header
    tableHTML += '<thead><tr>';
    headerCells.forEach(function(cell, index) {
        var alignment = alignments[index] || 'left';
        var alignStyle = alignment !== 'left' ? ' style="text-align: ' + alignment + ';"' : '';
        var processedCell = processInlineFormatting(cell);
        tableHTML += '<th' + alignStyle + '>' + processedCell + '</th>';
    });
    tableHTML += '</tr></thead>';
    
    // Add body rows
    if (dataLines.length > 0) {
        tableHTML += '<tbody>';
        dataLines.forEach(function(line) {
            var dataCells = parseTableRow(line);
            tableHTML += '<tr>';
            // Ensure we have the same number of cells as headers
            for (var index = 0; index < headerCells.length; index++) {
                var cell = dataCells[index] || '';
                var alignment = alignments[index] || 'left';
                var alignStyle = alignment !== 'left' ? ' style="text-align: ' + alignment + ';"' : '';
                var processedCell = processInlineFormatting(cell);
                // Handle empty cells
                if (!processedCell || !processedCell.trim()) {
                    processedCell = '&nbsp;';
                }
                tableHTML += '<td' + alignStyle + '>' + processedCell + '</td>';
            }
            tableHTML += '</tr>';
        });
        tableHTML += '</tbody>';
    }
    
    tableHTML += '</table></div>' + viewFullTableCTA;
    return tableHTML;
}

function parseTableRow(line) {
    if (!line || typeof line !== 'string') return [];
    
    // Remove leading and trailing pipes, then split by |
    var trimmed = line.trim();
    
    // Handle lines that start with |
    if (trimmed.startsWith('|')) {
        trimmed = trimmed.substring(1);
    }
    // Handle lines that end with |
    if (trimmed.endsWith('|')) {
        trimmed = trimmed.substring(0, trimmed.length - 1);
    }
    
    // Split by | but handle escaped pipes
    var cells = [];
    var currentCell = '';
    var i = 0;
    
    while (i < trimmed.length) {
        if (trimmed[i] === '\\' && i + 1 < trimmed.length && trimmed[i + 1] === '|') {
            // Escaped pipe - add literal pipe to current cell
            currentCell += '|';
            i += 2;
        } else if (trimmed[i] === '|') {
            // Cell delimiter
            cells.push(currentCell.trim());
            currentCell = '';
            i++;
        } else {
            currentCell += trimmed[i];
            i++;
        }
    }
    // Don't forget the last cell
    if (currentCell || cells.length > 0) {
        cells.push(currentCell.trim());
    }
    
    return cells;
}

function processInlineFormatting(text) {
    if (!text) return '';
    
    var processed = text;
    
    // Handle bold text **text** to <b>text</b>
    processed = processed.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    
    // Handle italic text *text* to <i>text</i> (but not if it's part of bold)
    // Use a safer approach without lookbehind for browser compatibility
    processed = processed.replace(/(^|[^*])\*([^*]+?)\*([^*]|$)/g, function(match, before, content, after) {
        return before + '<i>' + content + '</i>' + after;
    });
    
    // Handle code spans `code` to <code>code</code>
    processed = processed.replace(/`([^`]+)`/g, '<code>$1</code>');
    
    // Handle links [text](url)
    processed = processed.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
    
    // Handle citation links [[number]](url)
    processed = processed.replace(/\[\[(\d+)\]\]\(([^)]+)\)/g, '<a class="citation-circle" href="$2" target="_blank">$1</a>');
    
    // Handle citation format [number](url)
    processed = processed.replace(/\[(\d+)\]\(([^)]+)\)/g, '<a class="citation-circle" href="$2" target="_blank">$1</a>');
    
    return processed;
}

function processMarkdownAnswer(answer) {
    let processedAnswer = answer;
    let refCnt = 0;
    
    // Split content and references - look for "References" followed by line breaks
    const parts = processedAnswer.split(/References\s*\n/);
    let mainContent = parts[0] || '';
    const referencesContent = parts[1] || '';
    
    // Process Markdown tables first (before other formatting)
    mainContent = processMarkdownTables(mainContent);
    
    // Process main content
    // Handle bold text **text** to <b>text</b>
    mainContent = mainContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    
    // Handle italic text *text* to <i>text</i>
    mainContent = mainContent.replace(/\*(.*?)\*/g, '<i>$1</i>');
    
    // Process citations [[number]](url) 
	mainContent = mainContent.replace(/\[\[(\d+)\]\]\((https?:\/\/[^\)]+)\)/g, 
        '<a class="citation-circle" href="$2" target="_blank">$1</a>');
    
    // Process regular markdown links [text](url)
    mainContent = mainContent.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, 
        '<a href="$2" target="_blank">$1</a>');
    
    // Convert markdown headers to HTML
    mainContent = mainContent.replace(/^### \*\*(.*?)\*\*$/gm, '<h3><b>$1</b></h3>');
    mainContent = mainContent.replace(/^### (.*?)$/gm, '<h3><b>$1</b></h3>');
    mainContent = mainContent.replace(/^## \*\*(.*?)\*\*$/gm, '<h2><b>$1</b></h2>');
    mainContent = mainContent.replace(/^## (.*?)$/gm, '<h2>$1</h2>');
    mainContent = mainContent.replace(/^# \*\*(.*?)\*\*$/gm, '<h1><b>$1</b></h1>');
    mainContent = mainContent.replace(/^# (.*?)$/gm, '<h1>$1</h1>');
    
    // Handle horizontal rules (---)
    mainContent = mainContent.replace(/^---$/gm, '');
    
    // Handle bullet points
    mainContent = mainContent.replace(/^- (.*$)/gm, '<li>$1</li>');
    mainContent = mainContent.replace(/^  - (.*$)/gm, '<li style="margin-left: 20px;">$1</li>');
    
    // Wrap consecutive li elements in ul tags
    mainContent = mainContent.replace(/(<li>.*?<\/li>(\s*<li>.*?<\/li>)*)/gs, function(match) {
        return '<ul>' + match + '</ul>';
    });
    
    
    // Convert single line breaks to <br>
    // mainContent = mainContent.replace(/\n/g, '<br>');
    
    // Wrap in paragraph tags
    mainContent = '<p>' + mainContent + '</p>';
    
    // Fix elements that shouldn't be in paragraphs
    mainContent = mainContent.replace(/<p>(<h[1-6]>.*?<\/h[1-6]>)<\/p>/g, '$1');
    mainContent = mainContent.replace(/<p>(<hr>)<\/p>/g, '$1');
    mainContent = mainContent.replace(/<p>(<ul>.*?<\/ul>)<\/p>/gs, '$1');
    mainContent = mainContent.replace(/<p>(<div class="table-container">.*?<\/div>)<\/p>/gs, '$1');
    
    // Clean up empty paragraphs
    mainContent = mainContent.replace(/<p>\s*<\/p>/g, '');
    mainContent = mainContent.replace(/<p>\s*<br>\s*<\/p>/g, '');
    
    // Process references section if it exists
    let referencesHtml = '';
    if (referencesContent.trim()) {
        referencesHtml = '<ul>';
        
        // Split references by lines that start with •
        const refLines = referencesContent.split('\n').filter(line => line.trim());
        refLines.forEach(line => {
            line = line.trim();
            if (line.startsWith('•')) {
                // Remove the bullet point
                line = line.substring(1).trim();
                
                // Try multiple regex patterns to handle different formats
                let match = null;
                let num = '';
                let title = '';
                let url = '';
                
                // Pattern 1: [number - title](url)
                match = line.match(/\[(\d+)\s*-\s*([^\]]+)\]\((https?:\/\/[^\)]+)\)/);
                if (match) {
                    num = match[1];
                    title = match[2];
                    url = match[3];
                } else {
                    // Pattern 2: [number] - [title](url)
                    match = line.match(/\[(\d+)\]\s*-\s*\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/);
                    if (match) {
                        num = match[1];
                        title = match[2];
                        url = match[3];
                    } else {
                        // Pattern 3: Try to extract any number, title and url
                        const numMatch = line.match(/\[(\d+)/);
                        const urlMatch = line.match(/\((https?:\/\/[^\)]+)\)/);
                        
                        if (numMatch && urlMatch) {
                            num = numMatch[1];
                            url = urlMatch[1];
                            // Extract title by removing brackets and URL
                            title = line.replace(/\[(\d+)/, '').replace(/\]\([^\)]+\)/, '').replace(/^\s*-\s*/, '').trim();
                        }
                    }
                }
                
                
                if (num && title && url) {
                    refCnt++;
                    referencesHtml += `<li><a class="citation-circle" onclick="wmdPageLink('ai-search_ref-ar-click-${refCnt}', this);" href="${url}" target="_blank">${refCnt} - ${title}</a></li>`;
                } else if (url) {
                    // Fallback: use the entire line as title if we have a URL
                    const fallbackTitle = line.replace(/\([^\)]+\)/, '').replace(/\[|\]/g, '').trim();
                    refCnt++;
                    referencesHtml += `<li><a class="citation-circle" onclick="wmdPageLink('ai-search_ref-ar-click-${refCnt}', this);" href="${url}" target="_blank">${fallbackTitle}</a></li>`;
                }
            }
        });
        
        referencesHtml += '</ul>';
    }
    
    return mainContent + referencesHtml;
}

function setLeadConcept(conceptValue, source) {
    // Enhanced validation for concept value - must not be null, undefined, empty, whitespace, or invalid
    var trimmed = conceptValue;
    
    // Handle string values - trim and remove quotes if present
    if (typeof conceptValue === 'string') {
        trimmed = conceptValue.trim();
        // Remove quotes if present and trim again
        if ((trimmed.startsWith('"') && trimmed.endsWith('"')) || 
            (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
            trimmed = trimmed.slice(1, -1).trim();
        }
    }
    
    var isValidValue = conceptValue && 
                      typeof conceptValue === 'string' && 
                      trimmed !== '' && 
                      trimmed.length > 0 &&
                      !/^\s*$/.test(trimmed) &&  // Reject whitespace-only values
                      trimmed.toLowerCase() !== 'null' && 
                      trimmed.toLowerCase() !== 'none' && 
                      trimmed.toLowerCase() !== 'undefined' &&
                      trimmed !== '0' &&  // Reject string "0"
                      /^\d+$/.test(trimmed);  // Must be numeric (digits only)
    
    // Only execute on full-width landing page and with valid value
    if (!isValidValue || !_vars.isFullPage) {
        return;
    }
    
    // Use the cleaned/trimmed value
    conceptValue = trimmed;
    
    try {
        // Always set PageMetadata.pageSegVars.scg for both URL and API sources
        if (typeof PageMetadata !== 'undefined' && PageMetadata.pageSegVars) {
            PageMetadata.pageSegVars.scg = conceptValue;
        }
        
        // Also call adLib.gpt.setPageTarget for API sources or as backup
        if (window.adLib &&
            window.adLib.gpt &&
            typeof window.adLib.gpt.setPageTarget === 'function') {
            window.adLib.gpt.setPageTarget('scg', conceptValue);
        }
        
        // Update stored value (but don't use it for blocking future updates)
        _vars.leadConcept = {
            value: conceptValue,
            source: source // 'url' or 'api'
        };
        
    } catch (error) {
        console.error('Error setting lead concept:', error);
    }
}

var isConversationHistoryReady = false;

function buildAISearchUrlWithConversation() {
	const params = new URLSearchParams();
	const isFollowUpQuestion = document.querySelectorAll('.ai-search-question, .ai-search-asking-question').length > 1;
	const isLoggedIn = typeof PageMetadata !== 'undefined' && PageMetadata.authVar && Number(PageMetadata.authVar.authLevel) !== 0;
	if (isLoggedIn && _vars.conversationId && document.querySelectorAll('.answer').length > 0 && (isConversationHistoryReady || isFollowUpQuestion)) {
		params.append('conversationId', _vars.conversationId);
	}
	const baseUrl = 'https://www.' + _vars.friendlyEnv + 'medscape.com/ai-search';
	const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
	return shared.appendV1Param(url);
}

function handleFullAISearchClick(event) {
	event.preventDefault();
	const fullUrl = buildAISearchUrlWithConversation();
	wmdTrack('ai-search_modal', event.target);
	// Open in new tab and close modal (but not on article pages)
	window.open(fullUrl, '_blank');
	
	// Only close modal if not on article pages
	/* if (!_vars.isArticleMobile && !_vars.isArticlePage) {
		closeLayer();
	} */
}

function handleViewFullTableClick(event) {
	event.preventDefault();
	const fullUrl = buildAISearchUrlWithConversation();
	wmdTrack('ai-search_tbl-fv', event.target);
	window.open(fullUrl, '_blank');
}

// Event delegation for deep dive module (Vue component in A2A that renders dynamically)
// This captures A2A article context and opens modal before Vue calls aiQueryHandleSearch(prompt)
document.addEventListener('click', function(e) {
	var deepDiveBtn = e.target.closest('.deep-dive-link-button');
	if (!deepDiveBtn) return;
	
	// For A2A mode, capture article context from the clicked button's wrapper before searching.
	captureA2AArticleContext(deepDiveBtn.closest('.inf-art-wrap'));

	// For article pages, open the modal first - always maximized for deep dive clicks
	if (_vars.isArticlePage && !document.body.classList.contains('show-ai-search-modal')) {
		document.body.classList.add('show-ai-search-modal');
		// Hide the FAB when modal opens - use both class removal and display:none for reliability
		var fabEl = document.getElementById('ai-search-fab');
		if (fabEl) {
			fabEl.classList.remove('active');
			fabEl.style.display = 'none';
		}
		// Hide the sticky input wrapper
		var articleSearchWrapper = document.querySelector('.article-search-wrapper');
		if (articleSearchWrapper) {
			articleSearchWrapper.style.display = 'none';
		}
	}
	// Deep dive always opens maximized - remove minimized class to ensure proper CSS
	document.body.classList.remove('ai-search-modal-minimized');
	if (!document.body.classList.contains('ai-search-modal-maximized')) {
		document.body.classList.add('ai-search-modal-maximized');
	}
	
	var linkTextEl = deepDiveBtn.querySelector('.link-text');
	var query = linkTextEl ? linkTextEl.textContent.trim() : deepDiveBtn.textContent.trim();
	if (query) {
		_vars.isModalPromptClicked = true;
		_vars.queryId = generateQueryId();
		shared.setQueryWordCount(query);
		
		// Fire analytics
		var deepDiveLinks = deepDiveBtn.closest('.deep-dive-links');
		var linkIndex = deepDiveLinks ? Array.from(deepDiveLinks.querySelectorAll('.deep-dive-link-button')).indexOf(deepDiveBtn) + 1 : 1;
		if (typeof wmdPageLink !== 'undefined') {
			wmdPageLink('ai-search_deep-dive-clkc-' + linkIndex, e.target);
		}
		
		// Trigger the search
		shared.handleSearch(query);
	}
});

// Static Deep Dive pills rendered inside the Article Key Points card (.deep-dive-pill).
// Same behavior as the deep-dive-link-button above, but the query comes from data-prompt
// (the pill's visible label differs from the prompt it submits).
document.addEventListener('click', function(e) {
	var pill = e.target.closest('.deep-dive-pill');
	if (!pill) return;

	// For A2A mode, capture the article context from the clicked pill's feed article first.
	captureA2AArticleContext(pill.closest('.inf-art-wrap'));

	// For article pages, open the modal first - always maximized for deep dive clicks.
	if (_vars.isArticlePage && !document.body.classList.contains('show-ai-search-modal')) {
		document.body.classList.add('show-ai-search-modal');
		var fabEl = document.getElementById('ai-search-fab');
		if (fabEl) {
			fabEl.classList.remove('active');
			fabEl.style.display = 'none';
		}
		var articleSearchWrapper = document.querySelector('.article-search-wrapper');
		if (articleSearchWrapper) {
			articleSearchWrapper.style.display = 'none';
		}
	}
	// Deep dive always opens maximized.
	document.body.classList.remove('ai-search-modal-minimized');
	if (!document.body.classList.contains('ai-search-modal-maximized')) {
		document.body.classList.add('ai-search-modal-maximized');
	}

	var query = pill.getAttribute('data-prompt') || pill.textContent.trim();
	if (query) {
		_vars.isModalPromptClicked = true;
		_vars.queryId = generateQueryId();
		shared.setQueryWordCount(query);

		// Fire analytics keyed to the Deep Dive option: ar-ddkp_clinical / ar-ddkp_patient.
		var linkId = pill.getAttribute('data-link-id');
		if (typeof wmdPageLink !== 'undefined' && linkId) {
				wmdPageLink('ar-ddkp_' + linkId, e.target);
		}

		// Trigger the search
		shared.handleSearch(query);
	}
});

let disclaimerInitialized = false;

function initDisclaimerUI() {
	if (disclaimerInitialized) return;
	disclaimerInitialized = true;

	const isFullWidth = !!document.querySelector('.ai-search-full-width-container');

	// Full-width: populate the footer disclaimer container
	const footerDisclaimer = document.querySelector('.ai-search-footer-desclaimer');
	if (footerDisclaimer && !footerDisclaimer.querySelector('.ai-search-disclaimer-full')) {
		footerDisclaimer.innerHTML = _html.disclaimerInlineHtml(false);
	}

	// Non-full-width modal: replace static disclaimer text with the short inline version
	if (!isFullWidth) {
		const modalDisclaimer = document.querySelector('#ai-search-modal .ai-search-disclaimer');
		if (modalDisclaimer && !modalDisclaimer.querySelector('.ai-search-see-more')) {
			modalDisclaimer.innerHTML = _html.disclaimerInlineHtml(true);
		}
	}

	if (!document.querySelector('.ai-disclaimer-bottom-sheet')) {
		const sheetTarget = isFullWidth ? document.body : (document.querySelector('#ai-search-modal') || document.body);
		sheetTarget.insertAdjacentHTML('beforeend', _html.disclaimerBottomSheet(!isFullWidth));
	}

	const sheet = document.querySelector('.ai-disclaimer-bottom-sheet');
	if (!sheet) return;

	if (!isFullWidth) {
		sheet.classList.add('non-full-width');
	}

	const panel = sheet.querySelector('.ai-disclaimer-bs-panel');
	const closeBtn = sheet.querySelector('.ai-disclaimer-bs-close');

	function openSheet() {
		sheet.setAttribute('aria-hidden', 'false');
		sheet.classList.add('active');
	}

	function closeSheet() {
		sheet.classList.remove('active');
		sheet.setAttribute('aria-hidden', 'true');
	}

	// Direct listener on see-more link(s) — avoids document-delegation interference inside the modal
	document.querySelectorAll('.ai-search-see-more').forEach(function(el) {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			openSheet();
		});
	});

	// Close on outside click
	document.addEventListener('click', function(e) {
		if (
			sheet.classList.contains('active') &&
			!panel.contains(e.target) &&
			!e.target.classList.contains('ai-search-see-more')
		) {
			closeSheet();
		}
	});

	if (closeBtn) {
		closeBtn.addEventListener('click', function(e) {
			e.stopPropagation();
			closeSheet();
		});
	}

	// Tap outside panel close
	document.addEventListener('touchstart', function(e) {
		if (sheet.classList.contains('active') && !panel.contains(e.target)) {
			closeSheet();
		}
	}, { passive: true });


	// Swipe-down on panel close
	let touchStartY = 0;
	panel.addEventListener('touchstart', function(e) {
		touchStartY = e.touches[0].clientY;
	}, { passive: true });

	panel.addEventListener('touchend', function(e) {
		if (e.changedTouches[0].clientY - touchStartY > 50) {
			closeSheet();
		}
	}, { passive: true });
}

module.exports = {
bindUI: bindUI,
processMarkdownTables: processMarkdownTables
}
